// import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import DealView from './DealView';
// import SelectedContact from '../../contact/SelectedContact';
// import withPermission from '../../../utils/withPermission';
// import ActivityList from '../Deal/activity/ActivityList';
// import ProductDetails from './ProductDetails';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs";
// import { FaRegClock, FaUserEdit, FaFileInvoice, FaTag, FaAddressCard } from "react-icons/fa";
// import moment from "moment";
// import DealModal from './DealModal';
// const dealDetails = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") || "orderSplits";
//     const [dealDetails, setdealDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('orderSplits');
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);
//     const WithProPermission = withPermission(({ children }) => children, ['product-list']);

//     const [showModal, setShowModal] = useState(false);
//     const [selectedDeal, setSelectedDeal] = useState(null);
//     const [timelineUpdates, setTimelineUpdates] = useState([]);
//     const [organisations, setOrganisation] = useState([]);
//     const [deals, setDeal] = useState([]);
//     const [orderSplits, setOrderSplits] = useState([]);


//     const didFetchRef = useRef(false);
//     const fetchTimelineUpdates = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             // Define params object
//             let params = {};

//             params.deal_id = id;

//             // Ensure that at least one valid param exists
//             if (!params.deal_id) {
//                 console.warn("Missing deal_id, skipping API call.");
//                 return;
//             }

//             const response = await axios.get(`${backendUrl}/api/history/all`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`, 'Tenant-Origin': origin,
//                 },
//                 params, // Pass query parameters
//             });

//             setTimelineUpdates(response.data.data);
//         } catch (error) {
//             console.error("Error fetching timeline updates:", error);
//         }
//     };
//     const fetchdealDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/deals/${id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             console.log(response.data); // Check the data structure

//             setdealDetails(response.data.data); // Set the fetched data to state
//         } catch (error) {
//             console.error('Error fetching instance details:', error);
//         }
//     };
//     useEffect(() => {
//         if (!dealDetails) return;

//         const paymentTerm = dealDetails?.quotation?.project?.payment_term; // quarterly, half-yearly, yearly
//         const startDate = moment(dealDetails?.quotation?.project?.subscription_start_date);
//         const endDate = moment(dealDetails?.quotation?.project?.vendor_subscription_end_dates);
//         const name = dealDetails?.name;
//         const totalAmount = parseFloat(dealDetails?.quotation?.amount || 0);

//         let splits = [];
//         let incrementMonths = 0;

//         switch (paymentTerm) {
//             case "quarterly":
//                 incrementMonths = 3;
//                 break;
//             case "halfyearly":
//                 incrementMonths = 6;
//                 break;
//             case "yearly":
//                 incrementMonths = 12;
//                 break;
//             default:
//                 incrementMonths = 12;
//         }

//         // Calculate number of splits based on contract length
//         const totalMonths = endDate.diff(startDate, 'months') + 1; // include end month
//         const numSplits = Math.ceil(totalMonths / incrementMonths);

//         const amountPerSplit = (totalAmount / numSplits).toFixed(2);

//         for (let i = 0; i < numSplits; i++) {
//             const splitStart = moment(startDate).add(i * incrementMonths, 'months');
//             const splitEnd = moment(splitStart).add(incrementMonths, 'months').subtract(1, 'days');
//             const dueDate = splitStart; // due date can be start of split

//             splits.push({
//                 installment_no: i + 1,
//                 name: name,
//                 amount: amountPerSplit,
//                 start_date: splitStart.format("YYYY-MM-DD"),
//                 end_date: splitEnd.isAfter(endDate) ? endDate.format("YYYY-MM-DD") : splitEnd.format("YYYY-MM-DD"),
//                 due_date: dueDate.format("YYYY-MM-DD"),
//                 status: "Pending",
//             });
//         }
//         let remainingPaid = dealDetails?.quotation?.proforma_invoices
//             ?.reduce((sum, inv) => sum + parseFloat(inv.amount || 0), 0) || 0;

//         // Update split status based on paid amount
//         splits.forEach(split => {
//             if (remainingPaid >= parseFloat(split.amount)) {
//                 split.status = "Paid";
//                 remainingPaid -= parseFloat(split.amount);
//             } else {
//                 split.status = moment().isAfter(split.end_date) ? "Expired" : "Pending";
//             }
//         });

//         setOrderSplits(splits);
//     }, [dealDetails]);

// // useEffect(() => {
// //     if (!dealDetails) return;

// //     const name = dealDetails?.name;
// //     const productItems = dealDetails?.quotation?.product_item_details || [];

// //     const splits = productItems.map((item, index) => {
// //         const amount = (parseFloat(item.price) * parseFloat(item.quantity)) + (parseFloat(item.tax) || 0) - (parseFloat(item.discount) || 0);

// //         // For deferred, you can later split by term if needed
// //         const startDate = moment(dealDetails?.quotation?.project?.subscription_start_date);
// //         const endDate = moment(dealDetails?.quotation?.project?.vendor_subscription_end_dates);

// //         return {
// //             installment_no: index + 1,
// //             name: `${name} - ${item.product?.revenue_type || "unknown"}`,
// //             amount: amount.toFixed(2),
// //             start_date: startDate.format("YYYY-MM-DD"),
// //             end_date: endDate.format("YYYY-MM-DD"),
// //             due_date: startDate.format("YYYY-MM-DD"),
// //             status: "Pending",
// //         };
// //     });

// //     // Update status based on paid invoices
// //     let remainingPaid = dealDetails?.quotation?.proforma_invoices
// //         ?.reduce((sum, inv) => sum + parseFloat(inv.amount || 0), 0) || 0;

// //     splits.forEach(split => {
// //         if (remainingPaid >= parseFloat(split.amount)) {
// //             split.status = "Paid";
// //             remainingPaid -= parseFloat(split.amount);
// //         } else {
// //             split.status = moment().isAfter(split.end_date) ? "Expired" : "Pending";
// //         }
// //     });

// //     setOrderSplits(splits);
// // }, [dealDetails]);





//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchdealDetails(); // Only fetch data if it hasn't been done before
//             didFetchRef.current = true; // Mark that data has been fetched
//         }
//     }, [id]); // This will run only when `id` changes

//     useEffect(() => {
//         const queryParams = new URLSearchParams(location.search);
//         const activeTabParam = queryParams.get("activeTab") || "orderSplits";
//         setActiveTab(activeTabParam);
//     }, [location.search]);
//     const fetchOrganisation = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/organisation`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             const data = response.data.data;

//             setOrganisation(data);

//         } catch (error) {
//             console.error(`Error fetching :`, error);
//         }
//     };

//     const editDeal = async (contactId, updatedData) => {
//         try {

//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Corrected API endpoint with dynamic contact_type for editing
//             const response = await axios.put(`${backendUrl}/api/deals/${contactId}`, updatedData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             const updatedDeal = response.data.Data;

//             if (updatedDeal) {
//                 // Update dealDetails state
//                 setdealDetails((prevDeal) => ({
//                     ...prevDeal,
//                     ...updatedDeal, // Merge updated data
//                 }));
//                 setDeal((prevOrganisations) =>
//                     prevOrganisations
//                         ? prevOrganisations.map((org) =>
//                             org.id === updatedDeal.id ? updatedDeal : org
//                         )
//                         : [updatedDeal] // If null, set it as an array
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else
//                 console.error(`Error updating`, error);
//         }
//     };


//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     // Handle tab click to change active tab
//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//         navigate(`${location.pathname}?activeTab=${tab}`);

//     };
//     const getIcon = (action) => {
//         switch (action) {
//             case "Deal Created":
//                 return <FaRegClock className="icon created" />;
//             case "Deal Updated":
//                 return <FaUserEdit className="icon updated" />;
//             case "Contact Added":
//                 return <FaAddressCard className="icon invoice" />;
//             case "Product Added":
//                 return <FaFileInvoice className="icon invoice" />;
//             case "status":
//                 return <FaTag className="icon status" />;
//             default:
//                 return <FaRegClock className="icon default" />;
//         }
//     };
//     const groupByDate = (updates) => {
//         return updates.reduce((grouped, update) => {
//             const date = moment(update.created_at).format("MMM DD, YYYY");
//             if (!grouped[date]) {
//                 grouped[date] = [];
//             }
//             grouped[date].push(update);
//             return grouped;
//         }, {});
//     };
//     const groupedUpdates = groupByDate(timelineUpdates);
//     return (
//         <div className="main-content">

//             <div className="page-content">

//                 <div className="container-fluid">
//                     {/* Page Title */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 d-flex align-items-center">
//                                     <BsChevronLeft
//                                         className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>Opportunity</span>
//                                 </h4>
//                                 <div className="page-title-right br-font">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><Link to={`/deal/details/${id}?activeTab=dealInfo`}>
//                                             {dealDetails?.name || " Deal Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item active">Details</li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="p-6 max-w-7xl mx-auto">
//                         <>
//                             <Card className="mb-4 shadow-lg rounded-3 p-2 border-0" style={{ background: "linear-gradient(135deg, #f8f9fa, #ffffff)" }}>
//                                 {/* Header Section with Name and Edit Icon */}
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <Card.Title className="fw-bold  font-size-14  text-primary">{dealDetails?.name}</Card.Title>
//                                     <BiPencil
//                                         className="text-primary hover-effect2 edit-pencil"
//                                         onClick={() => {
//                                             setSelectedDeal(dealDetails); // Store organisation details
//                                             setShowModal(true); // Open modal
//                                         }} />
//                                 </div>
//                                 <Card.Body className="pt-3">
//                                     <div className="row">
//                                         {/* Left Section */}
//                                         <div className="col-md-6">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Organisation:</strong></span>
//                                                 <span className=" text-muted card-value">{dealDetails?.organisation?.name || '-'}</span>
//                                             </div>
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Stage:</strong></span>
//                                                 <span className=" text-muted card-value">{dealDetails?.stage || '-'}</span>
//                                             </div>
//                                         </div>

//                                         {/* Right Section */}
//                                         <div className="col-md-4">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Expected Revenue:</strong></span>
//                                                 <span className="fw-semibold text-primary card-value">{dealDetails?.expected_revenue || ''}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                             {showModal && (
//                                 <DealModal
//                                     showModal={showModal}
//                                     handleClose={() => setShowModal(false)}
//                                     dealId={id}
//                                     dealData={selectedDeal}
//                                     editDeal={editDeal}
//                                     fetchOrganisation={fetchOrganisation}
//                                     organisations={organisations}
//                                     setOrganisation={setOrganisation}

//                                 />
//                             )}
//                         </>
//                         <div className="row">
//                             <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2  font-size-13" role="tablist">
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'orderSplits' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('orderSplits')}
//                                                 role="tab"
//                                             >
//                                                 Order Splits
//                                             </a>
//                                         </li>

//                                         <WithActivityPermission>
//                                             <li className="nav-item">
//                                                 <a
//                                                     className={`nav-link ${activeTab === 'activityList' ? 'active' : ''}`}
//                                                     onClick={() => setActiveTab('activityList')}
//                                                     role="tab"
//                                                 >
//                                                     Activity
//                                                 </a>
//                                             </li>
//                                         </WithActivityPermission>
//                                         <WithContactPermission>
//                                             <li className="nav-item">
//                                                 <a
//                                                     className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                                     onClick={() => setActiveTab('contactList')}
//                                                     role="tab"
//                                                 >
//                                                     Contact
//                                                 </a>
//                                             </li>
//                                         </WithContactPermission>
//                                         <WithProPermission>
//                                             <li className="nav-item">
//                                                 <a
//                                                     className={`nav-link ${activeTab === 'productList' ? 'active' : ''}`}
//                                                     onClick={() => setActiveTab('productList')}
//                                                     role="tab"
//                                                 >
//                                                     Product
//                                                 </a>
//                                             </li>
//                                         </WithProPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'dealDetails' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('dealDetails')}
//                                                 role="tab"
//                                             >
//                                                 Deal Details
//                                             </a>
//                                         </li>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`}
//                                                 onClick={() => {
//                                                     setActiveTab('timeline');
//                                                     fetchTimelineUpdates(); // Fetch data only when clicking the Timeline tab
//                                                 }} role="tab"
//                                             >
//                                                 Timeline
//                                             </a>
//                                         </li>
//                                     </ul>


//                                     {/* Tab panes */}
//                                     <div className="tab-content p-4">
//                                         {/* Contact List Tab */}
//                                         {activeTab === "contactList" && dealDetails && (
//                                             <div className="tab-pane active" id="contact-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <SelectedContact
//                                                         dealId={dealDetails?.id}
//                                                         entityType="deal"
//                                                         fetchDealData={fetchdealDetails}
//                                                         dealData={dealDetails}
//                                                         setdealDetails={setdealDetails}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "activityList" && dealDetails && (
//                                             <div className="tab-pane active" id="activity-list" role="tabpanel">
//                                                 <div className=" p-3">
//                                                     <ActivityList
//                                                         dealId={dealDetails?.id}
//                                                         type='deal'
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "productList" && dealDetails && (
//                                             <div className="tab-pane active" id="product-list" role="tabpanel">
//                                                 <div className=" p-3">
//                                                     <ProductDetails
//                                                         dealId={dealDetails?.id}
//                                                         fetchDealData={fetchdealDetails}
//                                                         dealData={dealDetails}
//                                                         setdealDetails={setdealDetails}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {/* Organisation Details Tab */}
//                                         {activeTab === "dealDetails" && (
//                                             <div className="tab-pane active" id="Deal-details" role="tabpanel">
//                                                 <div>
//                                                     {dealDetails ? (
//                                                         <DealView data={dealDetails} dealId={id} setdealDetails={setdealDetails} />

//                                                     ) : (
//                                                         <p>Loading...</p>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "orderSplits" && dealDetails && (
//                                             <div className="tab-pane active" role="tabpanel">
//                                                 <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13">
//                                                     <thead>
//                                                         <tr>
//                                                             <th>#</th>
//                                                             <th>Name</th>
//                                                             <th>Amount</th>

//                                                             <th>Start Date</th>
//                                                             <th>Due Date</th>
//                                                             <th>Status</th>

//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {orderSplits.map(split => (
//                                                             <tr key={split.installment_no}>
//                                                                 <td>{split.installment_no}</td>
//                                                                 <td>{split.name}</td>
//                                                                 <td>{split?.amount}</td>
//                                                                 <td>{split?.start_date}</td>
//                                                                 <td>{split?.end_date}</td>
//                                                                 <td>
//                                                                     {split?.status === "Paid" && <span className="badge bg-success">{split.status}</span>}
//                                                                     {split?.status === "Pending" && <span className="badge bg-warning text-dark">{split.status}</span>}
//                                                                     {split?.status === "Expired" && <span className="badge bg-danger">{split.status}</span>}
//                                                                 </td>

//                                                             </tr>
//                                                         ))}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         )}

//                                         {activeTab === "timeline" && dealDetails && timelineUpdates.length > 0 ? (
//                                             <div className="tab-pane active" id="timeline" role="tabpanel">
//                                                 <h4></h4><br />
//                                                 <div>
//                                                     <div>

//                                                         <div className="timeline">
//                                                             {Object.entries(groupedUpdates)
//                                                                 .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA)) // Sort dates descending (latest first)
//                                                                 .map(([date, updates]) => (
//                                                                     <div key={date} className="timeline-date-group">
//                                                                         {/* Date Box */}
//                                                                         <div className="timeline-date-box  font-size-13">{date}</div>

//                                                                         {updates
//                                                                             .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort updates descending (latest first)
//                                                                             .map((update, index) => {
//                                                                                 let title = update.action;
//                                                                                 let details = null;

//                                                                                 // Function to format field names
//                                                                                 const formatFieldName = (field) => {
//                                                                                     return field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
//                                                                                 };

//                                                                                 // Handle different action types
//                                                                                 if (update.history_type === "activity") {
//                                                                                     if (update.action === "Meeting added" || update.action === "Task added" || update.action === "Call added") {
//                                                                                         title = `${update.action} - ${update.data.subject}`;
//                                                                                     } else if (update.action === "Meeting updated" || update.action === "Task updated" || update.action === "Call updated") {
//                                                                                         title = `${update.action}`;
//                                                                                         if (update.data.changes) {
//                                                                                             details = Object.entries(update.data.changes)
//                                                                                                 .filter(([key]) => !["created_at", "updated_at", "deal"].includes(key)) // Filter out unnecessary fields
//                                                                                                 .map(([key, change]) => (
//                                                                                                     <div key={key}>
//                                                                                                         <strong>{formatFieldName(key)}</strong> changed from <strong>{change.old}</strong> to <strong>{change.new}</strong>
//                                                                                                     </div>
//                                                                                                 ));
//                                                                                         }
//                                                                                     }
//                                                                                 } else if (update.history_type === "deal") {
//                                                                                     if (update.action === "Deal Updated" && update.data.old && update.data.new) {
//                                                                                         if (update.data.old.stage && update.data.new.stage && update.data.old.stage !== update.data.new.stage) {
//                                                                                             title = `Stage changed from ${update.data.old.stage} to ${update.data.new.stage}`;
//                                                                                             details = `Probability changed from ${update.data.old.probability}% to ${update.data.new.probability}%`;
//                                                                                         } else if (!update.data.old.stage && update.data.new.stage) {
//                                                                                             title = `Stage changed to ${update.data.new.stage}`;
//                                                                                             details = `Probability set to ${update.data.new.probability}%`;
//                                                                                         }
//                                                                                     }
//                                                                                 } else if (update.history_type === "deal") {
//                                                                                     if (update.action === "Deal created by converting the Deal") {
//                                                                                         title = `${update.action} - ${update.data?.Deal_name || 'Unknown Deal'}`;
//                                                                                     }
//                                                                                 }

//                                                                                 return (
//                                                                                     <div key={index} className="timeline-item">
//                                                                                         <div className="timeline-time">
//                                                                                             {moment(update.created_at).format("h:mm A")}
//                                                                                         </div>

//                                                                                         <div className="timeline-icon">{getIcon(update.action)}</div>

//                                                                                         <div className="timeline-line"></div>

//                                                                                         <div className="timeline-content">
//                                                                                             <p className="timeline-title">{title}</p>
//                                                                                             {details && <div className="timeline-details">{details}</div>}
//                                                                                             <p className="timeline-byline">
//                                                                                                 <small>by {update.created_by} {moment(update.created_at).format("MMM DD, YYYY")}</small>
//                                                                                             </p>
//                                                                                         </div>
//                                                                                     </div>
//                                                                                 );
//                                                                             })}
//                                                                     </div>
//                                                                 ))}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ) : activeTab === "timeline" ? (
//                                             <p>Loading timeline...</p>
//                                         ) : null}

//                                     </div>

//                                 </div>
//                             </div>

//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default dealDetails;


// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { Container, Card, Tabs, Tab, Button, Offcanvas, Badge } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsX } from "react-icons/bs";
// import {
//     FaRegClock,
//     FaUserEdit,
//     FaFileInvoice,
//     FaTag,
//     FaAddressCard,
//     FaBuilding,
//     FaUser,
//     FaStickyNote,
//     FaArrowRight
// } from "react-icons/fa";
// import moment from "moment";
// import DealView from './DealView';
// import SelectedContact from '../../contact/SelectedContact';
// import withPermission from '../../../utils/withPermission';
// import ActivityList from '../lead/activity/ActivityList';
// import DealModal from './DealModal';

// const DealDetails = ({ show, onHide, dealId }) => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") || "activityList";
//     const [dealDetails, setdealDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('activityList');
//     const [activities, setActivities] = useState([]); // Added activities state
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedDeal, setSelectedDeal] = useState(null);
//     const [timelineUpdates, setTimelineUpdates] = useState([]);
//     const [Deals, setDeal] = useState(null);
//     const [contacts, setContacts] = useState([]);
//     const [organisations, setOrganisation] = useState([]);
//     const [reopenOffcanvas, setReopenOffcanvas] = useState(false);

//     const didFetchRef = useRef(false);
//     const [localShow, setLocalShow] = useState(show);

//     // Sync with parent show prop
//     useEffect(() => {
//         setLocalShow(show);
//     }, [show]);
//     const fetchTimelineUpdates = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let params = {};
//             params.deal_id = dealId || id;

//             if (!params.deal_id) {
//                 console.warn("Missing Deal_id, skipping API call.");
//                 return;
//             }

//             const response = await axios.get(`${backendUrl}/api/history/all`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//                 params,
//             });

//             setTimelineUpdates(response.data.data);
//         } catch (error) {
//             console.error("Error fetching timeline updates:", error);
//         }
//     };

//     const fetchdealDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const currentId = dealId || id;
//             const response = await axios.get(`${backendUrl}/api/deals/${currentId}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             setdealDetails(response.data.data);
//         } catch (error) {
//             console.error('Error fetching Deal details:', error);
//         }
//     };

//     // Add function to fetch activities
//     const fetchActivities = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/activities`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params: {
//                     deal_id: dealId || id,
//                 },
//                 skipLoader: true,
//             });

//             setActivities(response.data.data || []);
//         } catch (error) {
//             console.error('Error fetching activities:', error);
//         }
//     };

//     const fetchContacts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contact`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const filteredContacts = response.data.Data.filter(
//                 contact => contact.type !== "instance" && contact.type !== "tenant"
//             );

//             setContacts(filteredContacts);
//         } catch (error) {
//             console.error('Error fetching contacts:', error);
//         }
//     };

//     const fetchOrganisation = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/organisation`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             setOrganisation(response.data.data);
//         } catch (error) {
//             console.error(`Error fetching organisations:`, error);
//         }
//     };

//     const editDeal = async (contactId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/deals/${contactId}`, updatedData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const updatedDeal = response.data.Data;

//             if (updatedDeal) {
//                 setdealDetails((prevDeal) => ({
//                     ...prevDeal,
//                     ...updatedDeal,
//                 }));

//                 setDeal((prevOrganisations) =>
//                     prevOrganisations
//                         ? prevOrganisations.map((org) =>
//                             org.id === updatedDeal.id ? updatedDeal : org
//                         )
//                         : [updatedDeal]
//                 );
//             }

//             setShowModal(false);
//             if (reopenOffcanvas) {
//                 setReopenOffcanvas(false);
//                 // Delay slightly to avoid rendering issues
//                 setTimeout(() => {
//                     onHide(false); // ensure offcanvas reopens
//                     // Or call a function to reopen with updated Deal
//                 }, 100);
//             }
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             } else {
//                 console.error(`Error updating Deal:`, error);
//             }
//         }
//     };

//     // useEffect(() => {
//     //     if (show) {
//     //         fetchdealDetails();
//     //         fetchActivities(); // Fetch activities when component shows
//     //     }
//     // }, [show, dealId]);

//     // useEffect(() => {
//     //     if (show && activeTab === 'timeline') {
//     //         fetchTimelineUpdates();
//     //     }
//     // }, [show, activeTab]);

//     useEffect(() => {
//         if (localShow && dealId) {
//             setdealDetails(null); // Clear previous data
//             fetchdealDetails();
//             fetchActivities();
//         }
//     }, [localShow, dealId]);

//     useEffect(() => {
//         if (localShow && activeTab === 'timeline') {
//             fetchTimelineUpdates();
//         }
//     }, [localShow, activeTab]);

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };
//     const handleOffcanvasClose = () => {
//         setdealDetails(null);
//         setActiveTab('activityList');
//         didFetchRef.current = false;
//        onHide(); // trigger exit animation
//     };


//     const getIcon = (action) => {
//         switch (action) {
//             case "Deal Created":
//                 return <div className="timeline-icon-circle bg-success"><FaRegClock className="text-white" size={12} /></div>;
//             case "Deal Updated":
//                 return <div className="timeline-icon-circle bg-primary"><FaUserEdit className="text-white" size={12} /></div>;
//             case "Contact Added":
//                 return <div className="timeline-icon-circle bg-info"><FaAddressCard className="text-white" size={12} /></div>;
//             case "status":
//                 return <div className="timeline-icon-circle bg-warning"><FaTag className="text-white" size={12} /></div>;
//             default:
//                 return <div className="timeline-icon-circle bg-secondary"><FaRegClock className="text-white" size={12} /></div>;
//         }
//     };

//     const groupByDate = (updates) => {
//         return updates.reduce((grouped, update) => {
//             const date = moment(update.created_at).format("MMM DD, YYYY");
//             if (!grouped[date]) {
//                 grouped[date] = [];
//             }
//             grouped[date].push(update);
//             return grouped;
//         }, {});
//     };

//     const groupedUpdates = groupByDate(timelineUpdates);
//     const [showModalAfterClose, setShowModalAfterClose] = useState(false);
//     const [modalDealData, setModalDealData] = useState(null);
//     const [closeOffcanvas, setCloseOffcanvas] = useState(false);

//     return (
//         <Offcanvas
//             show={localShow}
//             onHide={handleOffcanvasClose}
//             placement="end"
//             style={{ width: '1080px' }}
//             className="lead-offcanvas"
//         >

//             {/* Offcanvas Header */}
//             <Offcanvas.Header className="border-bottom bg-white py-3">
//                 <div className="d-flex justify-content-between align-items-center w-100">
//                     <div className="d-flex align-items-center">
//                         <div className="bg-primary rounded-circle p-2 me-3">
//                             <FaUser className="text-white" size={18} />
//                         </div>
//                         <div>
//                             <h5 className="mb-0 fw-bold text-dark">{dealDetails?.name}</h5>
//                             {/* <small className="text-muted">Deal ID: {dealId || id}</small> */}
//                         </div>
//                     </div>
//                     <div className="d-flex align-items-center gap-2">
//                         <Button
//                             variant="outline-primary"
//                             size="sm"
//                             onClick={() => {
//                                 setSelectedDeal(dealDetails);
//                                 setShowModal(true);
//                             }}
//                         >
//                                     <BiPencil className="me-1" />
//                             Edit Deal
//                         </Button>



//                     <Button
//                         variant="light"
//                         size="sm"
//                         onClick={handleOffcanvasClose}
//                         className="border-0"
//                     >
//                         <BsX size={20} />
//                     </Button>
//                 </div>
//             </div>
//         </Offcanvas.Header>

//             {/* Offcanvas Body */ }
//     <Offcanvas.Body className="p-0">
//         {/* Deal Summary Card */}
//         <div className="p-4 border-bottom bg-light">
//             <div className="row g-4">
//                 <div className="col-md-6">
//                     <div className="d-flex align-items-center">
//                         <div className="bg-white rounded-circle p-2 shadow-sm me-3">
//                             <FaBuilding className="text-primary" size={16} />
//                         </div>
//                         <div>
//                             <label className="text-muted small mb-1 d-block">Organisation</label>
//                             <h6 className="mb-0 fw-semibold text-dark">
//                                 {dealDetails?.organisation?.name || 'Not assigned'}
//                             </h6>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-md-6">
//                     <div className="d-flex align-items-center">
//                         <div className="bg-white rounded-circle p-2 shadow-sm me-3">
//                             <FaTag className="text-primary" size={16} />
//                         </div>
//                         <div>
//                             <label className="text-muted small mb-1 d-block">Lead Source</label>
//                             <h6 className="mb-0 fw-semibold text-dark text-capitalize">
//                                 {dealDetails?.lead_source ? dealDetails.lead_source.replace('_', ' ') : 'Not specified'}
//                             </h6>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-12">
//                     <div className="d-flex align-items-start">
//                         <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
//                             <FaStickyNote className="text-primary" size={16} />
//                         </div>
//                         <div className="flex-grow-1">
//                             <label className="text-muted small mb-1 d-block">Customer Type</label>
//                             <div>
//                                 <h6 className="mb-0 fw-semibold text-dark text-capitalize">
//                                     {dealDetails?.customer_type ? dealDetails.customer_type.replace('_', ' ') : 'Not specified'}
//                                 </h6>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//         {/* Navigation Tabs */}
//         <div className="border-bottom bg-white">
//             <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
//                 <WithActivityPermission>
//                     <li className="nav-item">
//                         <button
//                             className={`nav-link ${activeTab === 'activityList' ? 'active' : ''}`}
//                             onClick={() => handleTabClick('activityList')}
//                             role="tab"
//                         >
//                             <FaRegClock className="me-2" size={14} />
//                             Activities
//                             {activities.length > 0 && (
//                                 <span className="badge bg-primary ms-2">{activities.length}</span>
//                             )}
//                         </button>
//                     </li>
//                 </WithActivityPermission>
//                 <WithContactPermission>
//                     <li className="nav-item">
//                         <button
//                             className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                             onClick={() => handleTabClick('contactList')}
//                             role="tab"
//                         >
//                             <FaUser className="me-2" size={14} />
//                             Contacts
//                         </button>
//                     </li>
//                 </WithContactPermission>
//                 <li className="nav-item">
//                     <button
//                         className={`nav-link ${activeTab === 'dealDetails' ? 'active' : ''}`}
//                         onClick={() => handleTabClick('dealDetails')}
//                         role="tab"
//                     >
//                         <FaBuilding className="me-2" size={14} />
//                         Details
//                     </button>
//                 </li>
//                 <li className="nav-item">
//                     <button
//                         className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`}
//                         onClick={() => {
//                             handleTabClick('timeline');
//                             fetchTimelineUpdates();
//                         }}
//                         role="tab"
//                     >
//                         <FaRegClock className="me-2" size={14} />
//                         Timeline
//                         {timelineUpdates.length > 0 && (
//                             <span className="badge bg-primary ms-2">{timelineUpdates.length}</span>
//                         )}
//                     </button>
//                 </li>
//             </ul>
//         </div>

//         {/* Tab Content */}
//         <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             {/* Contact List Tab */}
//             {activeTab === "contactList" && dealDetails && (
//                 <div className="tab-pane active">
//                     <SelectedContact
//                         dealId={dealDetails?.id}
//                         entityType="deal"
//                         fetchDealData={fetchdealDetails}
//                         DealData={dealDetails}
//                         setdealDetails={setdealDetails}
//                     />
//                 </div>
//             )}

//             {/* Activity List Tab */}
//             {activeTab === "activityList" && dealDetails && (
//                 <div className="tab-pane active">
//                     <ActivityList
//                         dealId={dealDetails?.id}
//                         type='deal'
//                         fetchDealData={fetchdealDetails}
//                         DealData={dealDetails}
//                         setdealDetails={setdealDetails}
//                     />
//                 </div>
//             )}

//             {/* Deal Details Tab */}
//             {activeTab === "dealDetails" && (
//                 <div className="tab-pane active">
//                     {dealDetails ? (
//                         <DealView
//                             data={dealDetails}
//                             dealId={dealId || id}
//                             setdealDetails={setdealDetails}
//                         />
//                     ) : (
//                         <div className="text-center py-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                             <p className="mt-2 text-muted">Loading Deal details...</p>
//                         </div>
//                     )}
//                 </div>
//             )}

//             {/* Timeline Tab */}
//             {activeTab === "timeline" && dealDetails && (
//                 <div className="tab-pane active">
//                     {timelineUpdates.length > 0 ? (
//                         <div className="timeline-vertical">
//                             {Object.entries(groupedUpdates ?? {})
//                                 .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
//                                 .map(([date, updates]) => (
//                                     <div key={date} className="timeline-date-section mb-4">
//                                         <div className="timeline-date-header bg-light px-3 py-2 rounded mb-3">
//                                             <span className="fw-semibold text-dark">{date}</span>
//                                             <span className="badge bg-primary ms-2">{updates.length}</span>
//                                         </div>

//                                         <div className="timeline-events">
//                                             {updates
//                                                 .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//                                                 .map((update, index) => {
//                                                     let title = update.action;
//                                                     let details = null;
//                                                     let icon = null;

//                                                     const formatFieldName = (field) => {
//                                                         return field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
//                                                     };

//                                                     if (update.history_type === "activity") {
//                                                         if (update.action === "Meeting added" || update.action === "Task added" || update.action === "Call added") {
//                                                             title = `${update.action} - ${update.data.subject}`;
//                                                             icon = getIcon(update.action);
//                                                         } else if (update.action === "Meeting updated" || update.action === "Task updated" || update.action === "Call updated") {
//                                                             title = `${update.action}`;
//                                                             icon = getIcon(update.action);
//                                                             if (update.data.changes) {
//                                                                 details = Object.entries(update.data.changes)
//                                                                     .filter(([key]) => !["created_at", "updated_at", "Deal"].includes(key))
//                                                                     .map(([key, change]) => (
//                                                                         <div key={key} className="timeline-change-item">
//                                                                             <span className="text-muted">{formatFieldName(key)}:</span>
//                                                                             <span className="text-danger mx-1">{change.old}</span>
//                                                                             <FaArrowRight className="text-muted mx-1" size={10} />
//                                                                             <span className="text-success mx-1">{change.new}</span>
//                                                                         </div>
//                                                                     ));
//                                                             }
//                                                         }
//                                                     } else if (update.history_type === "Deal") {
//                                                         if (update.action === "Deal Updated" && update.data.old && update.data.new) {
//                                                             if (update.data.old.stage && update.data.new.stage && update.data.old.stage !== update.data.new.stage) {
//                                                                 title = `Stage Updated`;
//                                                                 details = (
//                                                                     <div className="timeline-stage-change">
//                                                                         <div className="d-flex align-items-center">
//                                                                             <span className="badge bg-light text-dark me-2">{update.data.old.stage}</span>
//                                                                             <FaArrowRight className="text-muted mx-2" size={12} />
//                                                                             <span className="badge bg-primary">{update.data.new.stage}</span>
//                                                                         </div>
//                                                                         <div className="text-muted small mt-1">
//                                                                             Probability: {update.data.old.probability}% → {update.data.new.probability}%
//                                                                         </div>
//                                                                     </div>
//                                                                 );
//                                                                 icon = getIcon("status");
//                                                             } else if (!update.data.old.stage && update.data.new.stage) {
//                                                                 title = `Stage Set`;
//                                                                 details = `Stage set to ${update.data.new.stage} with ${update.data.new.probability}% probability`;
//                                                                 icon = getIcon("status");
//                                                             }
//                                                         } else if (update.action === "Deal created by converting the Deal") {
//                                                             title = `Deal Converted`;
//                                                             details = `Converted to ${update.data?.Deal_name || 'Unknown Deal'}`;
//                                                             icon = getIcon("Deal Created");
//                                                         } else {
//                                                             icon = getIcon(update.action);
//                                                         }
//                                                     }

//                                                     return (
//                                                         <div key={index} className="timeline-item mb-3">
//                                                             <div className="d-flex">
//                                                                 <div className="timeline-icon-container me-3">
//                                                                     {icon || getIcon(update.action)}
//                                                                 </div>
//                                                                 <div className="timeline-content flex-grow-1">
//                                                                     <div className="bg-light rounded p-3">
//                                                                         <div className="d-flex justify-content-between align-items-start mb-2">
//                                                                             <h6 className="mb-0 fw-semibold text-dark">{title}</h6>
//                                                                             <small className="text-muted bg-white px-2 py-1 rounded">
//                                                                                 {moment(update.created_at).format("h:mm A")}
//                                                                             </small>
//                                                                         </div>
//                                                                         {details && (
//                                                                             <div className="timeline-details mt-2">
//                                                                                 {details}
//                                                                             </div>
//                                                                         )}
//                                                                         <div className="timeline-meta mt-2 pt-2 border-top">
//                                                                             <small className="text-muted">
//                                                                                 <FaUser className="me-1" size={12} />
//                                                                                 {update.created_by}
//                                                                             </small>
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     );
//                                                 })}
//                                         </div>
//                                     </div>
//                                 ))}
//                         </div>
//                     ) : (
//                         <div className="text-center py-5">
//                             <div className="bg-light rounded p-5">
//                                 <FaRegClock className="text-muted mb-3" size={32} />
//                                 <h6 className="text-muted">No Timeline Activity</h6>
//                                 <p className="text-muted small mb-0">
//                                     There's no activity recorded in the timeline yet.
//                                 </p>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             )}
//         </div>
//     </Offcanvas.Body>

//     {/* Deal Modal */ }
//     {
//         showModal && (
//             <DealModal
//                 showModal={showModal}
//                 handleClose={() => setShowModal(false)}
//                 dealData={selectedDeal}
//                 editDeal={editDeal}
//                 fetchOrganisation={fetchOrganisation}
//                 fetchContacts={fetchContacts}
//                 contacts={contacts}
//                 organisations={organisations}
//                 dealId={dealId || id}
//             />
//         )
//     }


//         </Offcanvas >
//     );
// };

// export default DealDetails;


// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { Container, Card, Tabs, Tab, Button, Offcanvas, Badge, Table } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsX } from "react-icons/bs";
// import {
//     FaRegClock,
//     FaUserEdit,
//     FaFileInvoice,
//     FaTag,
//     FaAddressCard,
//     FaBuilding,
//     FaUser,
//     FaStickyNote,
//     FaArrowRight,
//     FaFileAlt,
//     FaReceipt
// } from "react-icons/fa";
// import moment from "moment";
// import DealView from './DealView';
// import SelectedContact from '../../contact/SelectedContact';
// import withPermission from '../../../utils/withPermission';
// import ActivityList from '../lead/activity/ActivityList';
// import DealModal from './DealModal';
// import QuotationPreviewModal from '../../quotation/QuotationPreviewModal';

// const DealDetails = ({ show, onHide, dealId }) => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") || "activityList";
//     const [dealDetails, setdealDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('activityList');
//     const [activities, setActivities] = useState([]);
//     const [quotations, setQuotations] = useState([]);
//     const [poDetails, setPODetails] = useState(null);
//     const [showQuotationPreviewModal, setShowQuotationPreviewModal] = useState(false);
//     const [selectedQuotationForPreview, setSelectedQuotationForPreview] = useState(null);

//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedDeal, setSelectedDeal] = useState(null);
//     const [timelineUpdates, setTimelineUpdates] = useState([]);
//     const [Deals, setDeal] = useState(null);
//     const [contacts, setContacts] = useState([]);
//     const [organisations, setOrganisation] = useState([]);
//     const [reopenOffcanvas, setReopenOffcanvas] = useState(false);

//     const didFetchRef = useRef(false);
//     const [localShow, setLocalShow] = useState(show);

//     // Sync with parent show prop
//     useEffect(() => {
//         setLocalShow(show);
//     }, [show]);

//     // Fetch quotations using the deal's quotation_id
//     const fetchQuotations = async () => {
//         try {
//             if (!dealDetails?.quotation_id) {
//                 setQuotations([]);
//                 return;
//             }

//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Fetch the main quotation
//             const mainQuotationResponse = await axios.get(`${backendUrl}/api/quotations/${dealDetails.quotation_id}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const mainQuotation = mainQuotationResponse.data.quotation;

//             // If we need to fetch related quotations (versions), we can do it here
//             // For now, we'll just show the main quotation
//             const quotationsList = [mainQuotation];

//             // Group quotations by original quotation and version them
//             const groupedQuotations = groupQuotationsByVersion(quotationsList);
//             setQuotations(groupedQuotations);
//         } catch (error) {
//             console.error("Error fetching quotations:", error);
//             setQuotations([]);
//         }
//     };

//     // Group quotations by original and create versions
//     const groupQuotationsByVersion = (quotationsList) => {
//         const grouped = {};

//         quotationsList.forEach(quotation => {
//             const originalId = quotation.original_quotation_id || quotation.id;

//             if (!grouped[originalId]) {
//                 grouped[originalId] = [];
//             }

//             // Add version number
//             const version = grouped[originalId].length + 1;
//             grouped[originalId].push({
//                 ...quotation,
//                 version: version,
//                 displayRef: version === 1 ? quotation.ref_no : `${quotation.ref_no}-${version}`
//             });
//         });

//         // Flatten the grouped object into an array
//         return Object.values(grouped).flat();
//     };

//     // Fetch PO details from deal data
//     const fetchPODetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const currentId = dealId || id;
//             const response = await axios.get(`${backendUrl}/api/deals/${currentId}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const dealData = response.data.data;
//             setPODetails({
//                 po_attachment: dealData.po_attachment,
//                 po_value: dealData.po_value,
//                 issue_date: dealData.issue_date,
//                 po_number: dealData.po_number
//             });
//         } catch (error) {
//             console.error("Error fetching PO details:", error);
//         }
//     };

//     const fetchTimelineUpdates = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let params = {};
//             params.deal_id = dealId || id;

//             if (!params.deal_id) {
//                 console.warn("Missing Deal_id, skipping API call.");
//                 return;
//             }

//             const response = await axios.get(`${backendUrl}/api/history/all`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//                 params,
//             });

//             setTimelineUpdates(response.data.data);
//         } catch (error) {
//             console.error("Error fetching timeline updates:", error);
//         }
//     };

//     const fetchdealDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const currentId = dealId || id;
//             const response = await axios.get(`${backendUrl}/api/deals/${currentId}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const dealData = response.data.data;
//             setdealDetails(dealData);

//             // If deal has quotation_id, fetch quotations
//             if (dealData.quotation_id) {
//                 await fetchQuotationsForDeal(dealData.quotation_id);
//             } else {
//                 setQuotations([]);
//             }

//         } catch (error) {
//             console.error('Error fetching Deal details:', error);
//         }
//     };

//     // Enhanced function to fetch quotations using the deal's quotation_id
//     const fetchQuotationsForDeal = async (quotationId) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Fetch the main quotation
//             const mainQuotationResponse = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const mainQuotation = mainQuotationResponse.data.quotation;

//             // If you have a way to fetch quotation versions/history, add it here
//             // For example, if you have an endpoint like: /api/quotations/${quotationId}/versions
//             // const versionsResponse = await axios.get(`${backendUrl}/api/quotations/${quotationId}/versions`, {...});

//             const quotationsList = [mainQuotation];

//             // Group quotations by original quotation and version them
//             const groupedQuotations = groupQuotationsByVersion(quotationsList);
//             setQuotations(groupedQuotations);
//         } catch (error) {
//             console.error("Error fetching quotations:", error);
//             setQuotations([]);
//         }
//     };

//     // Fetch activities
//     const fetchActivities = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/activities`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params: {
//                     deal_id: dealId || id,
//                 },
//                 skipLoader: true,
//             });

//             setActivities(response.data.data || []);
//         } catch (error) {
//             console.error('Error fetching activities:', error);
//         }
//     };

//     const fetchContacts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contact`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const filteredContacts = response.data.Data.filter(
//                 contact => contact.type !== "instance" && contact.type !== "tenant"
//             );

//             setContacts(filteredContacts);
//         } catch (error) {
//             console.error('Error fetching contacts:', error);
//         }
//     };

//     const fetchOrganisation = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/organisation`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             setOrganisation(response.data.data);
//         } catch (error) {
//             console.error(`Error fetching organisations:`, error);
//         }
//     };

//     const editDeal = async (contactId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/deals/${contactId}`, updatedData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const updatedDeal = response.data.Data;

//             if (updatedDeal) {
//                 setdealDetails((prevDeal) => ({
//                     ...prevDeal,
//                     ...updatedDeal,
//                 }));

//                 setDeal((prevOrganisations) =>
//                     prevOrganisations
//                         ? prevOrganisations.map((org) =>
//                             org.id === updatedDeal.id ? updatedDeal : org
//                         )
//                         : [updatedDeal]
//                 );

//                 // Refresh quotations if quotation_id changed
//                 if (updatedDeal.quotation_id) {
//                     await fetchQuotationsForDeal(updatedDeal.quotation_id);
//                 }
//             }

//             setShowModal(false);
//             if (reopenOffcanvas) {
//                 setReopenOffcanvas(false);
//                 setTimeout(() => {
//                     onHide(false);
//                 }, 100);
//             }
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             } else {
//                 console.error(`Error updating Deal:`, error);
//             }
//         }
//     };

//     useEffect(() => {
//         if (localShow && dealId) {
//             setdealDetails(null);
//             fetchdealDetails();
//             fetchActivities();
//         }
//     }, [localShow, dealId]);

//     useEffect(() => {
//         if (localShow && activeTab === 'timeline') {
//             fetchTimelineUpdates();
//         } else if (localShow && activeTab === 'poDetails') {
//             fetchPODetails();
//         }
//         // quotations are now fetched automatically when dealDetails are loaded
//     }, [localShow, activeTab]);

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };

//     const handleOffcanvasClose = () => {
//         setdealDetails(null);
//         setActiveTab('activityList');
//         didFetchRef.current = false;
//         onHide();
//     };

//     // Handle quotation view
//     const handleViewQuotation = async (quotationId) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             setSelectedQuotationForPreview(response.data.quotation);
//             setShowQuotationPreviewModal(true);
//         } catch (error) {
//             console.error("Error fetching quotation for preview:", error);
//         }
//     };

//     // Handle download PDF
//     const handleDownloadPDF = async (quotationId, refNo) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}/download`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 responseType: 'blob'
//             });

//             const blob = new Blob([response.data], { type: 'application/pdf' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', `Quotation_${refNo}.pdf`);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//         } catch (error) {
//             console.error('Error downloading PDF:', error);
//         }
//     };

//     // Check if deal has quotation
//     const hasQuotation = dealDetails?.quotation_id;

//     const getIcon = (action) => {
//         switch (action) {
//             case "Deal Created":
//                 return <div className="timeline-icon-circle bg-success"><FaRegClock className="text-white" size={12} /></div>;
//             case "Deal Updated":
//                 return <div className="timeline-icon-circle bg-primary"><FaUserEdit className="text-white" size={12} /></div>;
//             case "Contact Added":
//                 return <div className="timeline-icon-circle bg-info"><FaAddressCard className="text-white" size={12} /></div>;
//             case "status":
//                 return <div className="timeline-icon-circle bg-warning"><FaTag className="text-white" size={12} /></div>;
//             default:
//                 return <div className="timeline-icon-circle bg-secondary"><FaRegClock className="text-white" size={12} /></div>;
//         }
//     };

//     const groupByDate = (updates) => {
//         return updates.reduce((grouped, update) => {
//             const date = moment(update.created_at).format("MMM DD, YYYY");
//             if (!grouped[date]) {
//                 grouped[date] = [];
//             }
//             grouped[date].push(update);
//             return grouped;
//         }, {});
//     };

//     const groupedUpdates = groupByDate(timelineUpdates);

//     // Attachment Preview Component for PO
//     // Enhanced Attachment Preview Component for PO
//     const AttachmentPreview = ({ attachmentUrl, showOriginalName = false }) => {
//         if (!attachmentUrl) return null;

//         const url = `${process.env.REACT_APP_BACKEND_URL}/storage/${attachmentUrl}`;
//         const fileName = attachmentUrl.split('/').pop();
//         const fileType = fileName.split('.').pop().toLowerCase();

//         const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(fileType);
//         const isPDF = fileType === 'pdf';
//         const isDocument = ['doc', 'docx', 'txt'].includes(fileType);
//         const isSpreadsheet = ['xls', 'xlsx', 'csv'].includes(fileType);

//         const getFileIcon = () => {
//             if (isPDF) return 'mdi-file-pdf-box text-danger';
//             if (isImage) return 'mdi-file-image text-success';
//             if (isDocument) return 'mdi-file-document text-primary';
//             if (isSpreadsheet) return 'mdi-file-excel text-success';
//             return 'mdi-file-document-outline text-secondary';
//         };

//         return (
//             <div className="border rounded bg-white p-3">
//                 <div className="d-flex align-items-center justify-content-between mb-3">
//                     <div className="d-flex align-items-center">
//                         <i className={`mdi ${getFileIcon()} display-6 me-3`}></i>
//                         <div>
//                             <h6 className="mb-1 text-dark">{showOriginalName ? fileName : 'PO Attachment'}</h6>
//                             <small className="text-muted">
//                                 {fileType.toUpperCase()} • {moment().format('MMM DD, YYYY')}
//                             </small>
//                         </div>
//                     </div>
//                     <Badge bg={isPDF ? "danger" : isImage ? "success" : "primary"}>
//                         {fileType.toUpperCase()}
//                     </Badge>
//                 </div>

//                 <div className="border rounded" style={{ maxHeight: '400px', overflow: 'auto' }}>
//                     {isImage ? (
//                         <img
//                             src={url}
//                             alt="PO Attachment"
//                             className="img-fluid w-100"
//                             style={{ maxHeight: '350px', objectFit: 'contain' }}
//                         />
//                     ) : isPDF ? (
//                         <iframe
//                             src={`${url}#toolbar=0&navpanes=0&view=FitH`}
//                             title="PO Attachment"
//                             width="100%"
//                             height="350px"
//                             frameBorder="0"
//                             className="border-0"
//                         />
//                     ) : (
//                         <div className="text-center py-5">
//                             <i className={`mdi ${getFileIcon()} display-1 text-muted mb-3`}></i>
//                             <p className="text-muted mb-2">Preview not available</p>
//                             <small className="text-muted">
//                                 Download the file to view {isDocument ? 'document' : isSpreadsheet ? 'spreadsheet' : 'content'}
//                             </small>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <Offcanvas
//             show={localShow}
//             onHide={handleOffcanvasClose}
//             placement="end"
//             style={{ width: '1050px' }}
//             className="lead-offcanvas"
//         >

//             {/* Offcanvas Header */}
//             <Offcanvas.Header className="border-bottom bg-white py-3">
//                 <div className="d-flex justify-content-between align-items-center w-100">
//                     <div className="d-flex align-items-center">
//                         <div className="bg-primary rounded-circle p-2 me-3">
//                             <FaUser className="text-white" size={18} />
//                         </div>
//                         <div>
//                             <h5 className="mb-0 fw-bold text-dark">{dealDetails?.name}</h5>
//                         </div>
//                     </div>
//                     <div className="d-flex align-items-center gap-2">
//                         <Button
//                             variant="outline-primary"
//                             size="sm"
//                             onClick={() => {
//                                 setSelectedDeal(dealDetails);
//                                 setShowModal(true);
//                             }}
//                         >
//                             <BiPencil className="me-1" />
//                             Edit Deal
//                         </Button>
//                         <Button
//                             variant="light"
//                             size="sm"
//                             onClick={handleOffcanvasClose}
//                             className="border-0"
//                         >
//                             <BsX size={20} />
//                         </Button>
//                     </div>
//                 </div>
//             </Offcanvas.Header>

//             {/* Offcanvas Body */}
//             <Offcanvas.Body className="p-0">
//                 {/* Deal Summary Card */}
//                 <div className="p-4 border-bottom bg-light">
//                     <div className="row g-4">
//                         <div className="col-md-6">
//                             <div className="d-flex align-items-center">
//                                 <div className="bg-white rounded-circle p-2 shadow-sm me-3">
//                                     <FaBuilding className="text-primary" size={16} />
//                                 </div>
//                                 <div>
//                                     <label className="text-muted small mb-1 d-block">Organisation</label>
//                                     <h6 className="mb-0 fw-semibold text-dark">
//                                         {dealDetails?.organisation?.name || 'Not assigned'}
//                                     </h6>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-md-6">
//                             <div className="d-flex align-items-center">
//                                 <div className="bg-white rounded-circle p-2 shadow-sm me-3">
//                                     <FaTag className="text-primary" size={16} />
//                                 </div>
//                                 <div>
//                                     <label className="text-muted small mb-1 d-block">Lead Source</label>
//                                     <h6 className="mb-0 fw-semibold text-dark text-capitalize">
//                                         {dealDetails?.lead_source ? dealDetails.lead_source.replace('_', ' ') : 'Not specified'}
//                                     </h6>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-12">
//                             <div className="d-flex align-items-start">
//                                 <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
//                                     <FaStickyNote className="text-primary" size={16} />
//                                 </div>
//                                 <div className="flex-grow-1">
//                                     <label className="text-muted small mb-1 d-block">Customer Type</label>
//                                     <div>
//                                         <h6 className="mb-0 fw-semibold text-dark text-capitalize">
//                                             {dealDetails?.customer_type ? dealDetails.customer_type.replace('_', ' ') : 'Not specified'}
//                                         </h6>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Navigation Tabs - UPDATED WITH NEW TABS */}
//                 <div className="border-bottom bg-white">
//                     <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
//                         <WithActivityPermission>
//                             <li className="nav-item">
//                                 <button
//                                     className={`nav-link ${activeTab === 'activityList' ? 'active' : ''}`}
//                                     onClick={() => handleTabClick('activityList')}
//                                     role="tab"
//                                 >
//                                     <FaRegClock className="me-2" size={14} />
//                                     Activities
//                                     {activities.length > 0 && (
//                                         <span className="badge bg-primary ms-2">{activities.length}</span>
//                                     )}
//                                 </button>
//                             </li>
//                         </WithActivityPermission>
//                         <WithContactPermission>
//                             <li className="nav-item">
//                                 <button
//                                     className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                     onClick={() => handleTabClick('contactList')}
//                                     role="tab"
//                                 >
//                                     <FaUser className="me-2" size={14} />
//                                     Contacts
//                                 </button>
//                             </li>
//                         </WithContactPermission>

//                         {/* NEW: Quotations Tab */}
//                         <li className="nav-item">
//                             <button
//                                 className={`nav-link ${activeTab === 'quotations' ? 'active' : ''}`}
//                                 onClick={() => handleTabClick('quotations')}
//                                 role="tab"
//                             >
//                                 <FaFileAlt className="me-2" size={14} />
//                                 Quotations
//                                 {hasQuotation && (
//                                     <span className="badge bg-primary ms-2">1</span>
//                                 )}
//                             </button>
//                         </li>
//                         {/* NEW: PO Details Tab */}
//                         <li className="nav-item">
//                             <button
//                                 className={`nav-link ${activeTab === 'poDetails' ? 'active' : ''}`}
//                                 onClick={() => handleTabClick('poDetails')}
//                                 role="tab"
//                             >
//                                 <FaReceipt className="me-2" size={14} />
//                                 PO Details
//                             </button>
//                         </li>
//                         <li className="nav-item">
//                             <button
//                                 className={`nav-link ${activeTab === 'dealDetails' ? 'active' : ''}`}
//                                 onClick={() => handleTabClick('dealDetails')}
//                                 role="tab"
//                             >
//                                 <FaBuilding className="me-2" size={14} />
//                                 Details
//                             </button>
//                         </li>
//                         <li className="nav-item">
//                             <button
//                                 className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`}
//                                 onClick={() => {
//                                     handleTabClick('timeline');
//                                     fetchTimelineUpdates();
//                                 }}
//                                 role="tab"
//                             >
//                                 <FaRegClock className="me-2" size={14} />
//                                 Timeline
//                                 {timelineUpdates.length > 0 && (
//                                     <span className="badge bg-primary ms-2">{timelineUpdates.length}</span>
//                                 )}
//                             </button>
//                         </li>
//                     </ul>
//                 </div>

//                 {/* Tab Content - UPDATED WITH NEW TABS */}
//                 <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>

//                     {/* Contact List Tab */}
//                     {activeTab === "contactList" && dealDetails && (
//                         <div className="tab-pane active">
//                             <SelectedContact
//                                 dealId={dealDetails?.id}
//                                 entityType="deal"
//                                 fetchDealData={fetchdealDetails}
//                                 DealData={dealDetails}
//                                 setdealDetails={setdealDetails}
//                             />
//                         </div>
//                     )}

//                     {/* Activity List Tab */}
//                     {activeTab === "activityList" && dealDetails && (
//                         <div className="tab-pane active">
//                             <ActivityList
//                                 dealId={dealDetails?.id}
//                                 type='deal'
//                                 fetchDealData={fetchdealDetails}
//                                 DealData={dealDetails}
//                                 setdealDetails={setdealDetails}
//                             />
//                         </div>
//                     )}

//                     {/* Deal Details Tab */}
//                     {activeTab === "dealDetails" && (
//                         <div className="tab-pane active">
//                             {dealDetails ? (
//                                 <DealView
//                                     data={dealDetails}
//                                     dealId={dealId || id}
//                                     setdealDetails={setdealDetails}
//                                 />
//                             ) : (
//                                 <div className="text-center py-5">
//                                     <div className="spinner-border text-primary" role="status">
//                                         <span className="visually-hidden">Loading...</span>
//                                     </div>
//                                     <p className="mt-2 text-muted">Loading Deal details...</p>
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     {/* NEW: Quotations Tab */}
//                     {activeTab === "quotations" && (
//                         <div className="tab-pane active">
//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                 <h5 className="mb-0">Quotations</h5>
//                                 {hasQuotation && (
//                                     <Badge bg="primary">{quotations.length} Quotation(s)</Badge>
//                                 )}
//                             </div>

//                             {hasQuotation ? (
//                                 quotations.length > 0 ? (
//                                     <div className="contacts-table-modern">
//                                         <div className="table-responsive">
//                                             <table className="table table-modern">
//                                                 <thead>
//                                                     <tr>
//                                                         <th>Reference No</th>
//                                                         <th>Version</th>
//                                                         <th>Amount</th>
//                                                         <th>Status</th>
//                                                         <th>Created Date</th>
//                                                         <th>Actions</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {quotations.map((quotation) => (
//                                                         <tr key={quotation.id}>
//                                                             <td>
//                                                                 <strong>{quotation.displayRef}</strong>
//                                                             </td>
//                                                             <td>
//                                                                 <Badge bg={quotation.version === 1 ? "success" : "info"}>
//                                                                     v{quotation.version}
//                                                                 </Badge>
//                                                             </td>
//                                                             <td>
//                                                                 {Number(quotation.amount || 0).toLocaleString('en-US', {
//                                                                     minimumFractionDigits: 2,
//                                                                     maximumFractionDigits: 2
//                                                                 })}
//                                                             </td>
//                                                             <td>
//                                                                 <Badge bg={
//                                                                     quotation.quotation_status === 'accepted' ? 'success' :
//                                                                         quotation.quotation_status === 'rejected' ? 'danger' :
//                                                                             quotation.quotation_status === 'sent' ? 'primary' : 'secondary'
//                                                                 }>
//                                                                     {quotation.quotation_status}
//                                                                 </Badge>
//                                                             </td>
//                                                             <td>
//                                                                 {moment(quotation.created_at).format('MMM DD, YYYY')}
//                                                             </td>
//                                                             <td>
//                                                                 <div className="btn-group btn-group-sm">
//                                                                     <button
//                                                                         className="btn btn-outline-primary"
//                                                                         onClick={() => handleViewQuotation(quotation.id)}
//                                                                     >
//                                                                         View
//                                                                     </button>
//                                                                     <button
//                                                                         className="btn btn-outline-secondary"
//                                                                         onClick={() => handleDownloadPDF(quotation.id, quotation.displayRef)}
//                                                                     >
//                                                                         PDF
//                                                                     </button>
//                                                                 </div>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="text-center py-5">
//                                         <div className="spinner-border text-primary" role="status">
//                                             <span className="visually-hidden">Loading...</span>
//                                         </div>
//                                         <p className="mt-2 text-muted">Loading quotations...</p>
//                                     </div>
//                                 )
//                             ) : (
//                                 <div className="text-center py-5">
//                                     <div className="bg-light rounded p-5">
//                                         <FaFileAlt className="text-muted mb-3" size={32} />
//                                         <h6 className="text-muted">No Quotations Found</h6>
//                                         <p className="text-muted small mb-0">
//                                             No quotations have been created for this deal yet.
//                                         </p>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     {/* NEW: PO Details Tab */}
//                     {/* NEW: PO Details Tab */}
//                     {activeTab === "poDetails" && (
//                         <div className="tab-pane active">
//                             <div className="d-flex justify-content-between align-items-center mb-4">
//                                 <h5 className="mb-0 text-dark">Purchase Order Details</h5>
//                                 <Badge bg={poDetails?.po_attachment ? "success" : "secondary"} className="fs-6">
//                                     {poDetails?.po_attachment ? "PO Attached" : "No PO"}
//                                 </Badge>
//                             </div>

//                             {poDetails ? (
//                                 <div className="row">
//                                     {/* PO Basic Information Card */}
//                                     <div className="col-lg-12">
//                                         <Card className="border-0 shadow-sm mb-4">
//                                             <Card.Header className="bg-white border-bottom-0 py-3">
//                                                 <h6 className="mb-0 text-dark">
//                                                     <FaReceipt className="me-2 text-primary" />
//                                                     PO Information
//                                                 </h6>
//                                             </Card.Header>
//                                             <Card.Body className="p-4">
//                                                 <div className="row g-4">
//                                                     <div className="col-md-6">
//                                                         <div className="d-flex align-items-start">
//                                                             <div className="bg-light rounded p-2 me-3">
//                                                                 <FaReceipt className="text-primary" size={16} />
//                                                             </div>
//                                                             <div className="flex-grow-1">
//                                                                 <label className="form-label text-muted small mb-1">PO Number</label>
//                                                                 <p className="mb-0 fw-semibold text-dark fs-6">
//                                                                     {poDetails.po_number || (
//                                                                         <span className="text-muted fw-normal">Not specified</span>
//                                                                     )}
//                                                                 </p>
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-md-6">
//                                                         <div className="d-flex align-items-start">
//                                                             <div className="bg-light rounded p-2 me-3">
//                                                                 <i className="mdi mdi-currency-usd text-primary"></i>
//                                                             </div>
//                                                             <div className="flex-grow-1">
//                                                                 <label className="form-label text-muted small mb-1">PO Value</label>
//                                                                 <p className="mb-0 fw-semibold text-dark fs-6">
//                                                                     {poDetails.po_value ? (
//                                                                         <>
//                                                                             {Number(poDetails.po_value).toLocaleString('en-US', {
//                                                                                 style: 'currency',
//                                                                                 currency: 'USD',
//                                                                                 minimumFractionDigits: 2,
//                                                                                 maximumFractionDigits: 2
//                                                                             })}
//                                                                         </>
//                                                                     ) : (
//                                                                         <span className="text-muted fw-normal">Not specified</span>
//                                                                     )}
//                                                                 </p>
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-md-6">
//                                                         <div className="d-flex align-items-start">
//                                                             <div className="bg-light rounded p-2 me-3">
//                                                                 <i className="mdi mdi-calendar text-primary"></i>
//                                                             </div>
//                                                             <div className="flex-grow-1">
//                                                                 <label className="form-label text-muted small mb-1">Issue Date</label>
//                                                                 <p className="mb-0 fw-semibold text-dark fs-6">
//                                                                     {poDetails.issue_date ? (
//                                                                         <>
//                                                                             {moment(poDetails.issue_date).format('MMM DD, YYYY')}
//                                                                             <small className="text-muted d-block">
//                                                                                 ({moment(poDetails.issue_date).fromNow()})
//                                                                             </small>
//                                                                         </>
//                                                                     ) : (
//                                                                         <span className="text-muted fw-normal">Not specified</span>
//                                                                     )}
//                                                                 </p>
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     {/* <div className="col-md-6">
//                                     <div className="d-flex align-items-start">
//                                         <div className="bg-light rounded p-2 me-3">
//                                             <i className="mdi mdi-file-document-outline text-primary"></i>
//                                         </div>
//                                         <div className="flex-grow-1">
//                                             <label className="form-label text-muted small mb-1">Status</label>
//                                             <div>
//                                                 <Badge 
//                                                     bg={
//                                                         poDetails.po_attachment && poDetails.po_value 
//                                                             ? "success" 
//                                                             : poDetails.po_attachment 
//                                                                 ? "warning" 
//                                                                 : "secondary"
//                                                     }
//                                                     className="fs-7"
//                                                 >
//                                                     {poDetails.po_attachment && poDetails.po_value 
//                                                         ? "Completed" 
//                                                         : poDetails.po_attachment 
//                                                             ? "Partial" 
//                                                             : "Pending"
//                                                     }
//                                                 </Badge>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div> */}
//                                                 </div>
//                                             </Card.Body>
//                                         </Card>
//                                     </div>

//                                     {/* PO Status Summary Card */}
//                                     {/* <div className="col-lg-4">
//                     <Card className="border-0 shadow-sm mb-4">
//                         <Card.Header className="bg-white border-bottom-0 py-3">
//                             <h6 className="mb-0 text-dark">
//                                 <i className="mdi mdi-clipboard-check-outline me-2 text-primary"></i>
//                                 PO Status
//                             </h6>
//                         </Card.Header>
//                         <Card.Body className="p-4">
//                             <div className="d-flex flex-column gap-3">
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <span className="text-muted small">PO Number</span>
//                                     <Badge bg={poDetails.po_number ? "success" : "secondary"} className="fs-7">
//                                         {poDetails.po_number ? "Provided" : "Missing"}
//                                     </Badge>
//                                 </div>

//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <span className="text-muted small">PO Value</span>
//                                     <Badge bg={poDetails.po_value ? "success" : "secondary"} className="fs-7">
//                                         {poDetails.po_value ? "Set" : "Missing"}
//                                     </Badge>
//                                 </div>

//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <span className="text-muted small">Issue Date</span>
//                                     <Badge bg={poDetails.issue_date ? "success" : "secondary"} className="fs-7">
//                                         {poDetails.issue_date ? "Set" : "Missing"}
//                                     </Badge>
//                                 </div>

//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <span className="text-muted small">Attachment</span>
//                                     <Badge bg={poDetails.po_attachment ? "success" : "secondary"} className="fs-7">
//                                         {poDetails.po_attachment ? "Uploaded" : "Missing"}
//                                     </Badge>
//                                 </div>
//                             </div>
//                         </Card.Body>
//                     </Card>
//                 </div> */}

//                                     {/* PO Attachment Card */}
//                                     <div className="col-12">
//                                         <Card className="border-0 shadow-sm">
//                                             <Card.Header className="bg-white border-bottom-0 py-3">
//                                                 <h6 className="mb-0 text-dark">
//                                                     <i className="mdi mdi-paperclip me-2 text-primary"></i>
//                                                     PO Attachment
//                                                 </h6>
//                                             </Card.Header>
//                                             <Card.Body className="p-4">
//                                                 {poDetails.po_attachment ? (
//                                                     <div className="row align-items-center">
//                                                         <div className="col-md-8">
//                                                             <AttachmentPreview
//                                                                 attachmentUrl={poDetails.po_attachment}
//                                                                 showOriginalName={true}
//                                                             />
//                                                         </div>
//                                                         {/* <div className="col-md-4">
//                                         <div className="d-flex flex-column gap-2">
//                                             <Button
//                                                 variant="outline-primary"
//                                                 size="sm"
//                                                 onClick={() => {
//                                                     const url = `${process.env.REACT_APP_BACKEND_URL}/storage/${poDetails.po_attachment}`;
//                                                     window.open(url, '_blank');
//                                                 }}
//                                                 className="d-flex align-items-center justify-content-center"
//                                             >

//                                             </Button>
//                                             <Button
//                                                 variant="outline-success"
//                                                 size="sm"
//                                                 onClick={() => {
//                                                     const url = `${process.env.REACT_APP_BACKEND_URL}/storage/${poDetails.po_attachment}`;
//                                                     const link = document.createElement('a');
//                                                     link.href = url;
//                                                     link.setAttribute('download', poDetails.po_attachment.split('/').pop());
//                                                     document.body.appendChild(link);
//                                                     link.click();
//                                                     link.remove();
//                                                 }}
//                                                 className="d-flex align-items-center justify-content-center"
//                                             >
//                                                 <i className="mdi mdi-download me-2"></i>
//                                                 Download
//                                             </Button>
//                                         </div>
//                                     </div> */}
//                                                     </div>
//                                                 ) : (
//                                                     <div className="text-center py-5">
//                                                         <div className="bg-light rounded p-5">
//                                                             <i className="mdi mdi-file-remove-outline display-4 text-muted mb-3"></i>
//                                                             <h6 className="text-muted">No PO Attachment</h6>
//                                                             <p className="text-muted small mb-3">
//                                                                 No purchase order attachment has been uploaded for this deal.
//                                                             </p>
//                                                             <Badge bg="secondary" className="fs-7">
//                                                                 Awaiting Upload
//                                                             </Badge>
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                             </Card.Body>
//                                         </Card>
//                                     </div>

//                                     {/* Action Buttons */}
//                                     {/* <div className="col-12 mt-4">
//                     <Card className="border-0 bg-light">
//                         <Card.Body className="p-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <h6 className="mb-1 text-dark">PO Management</h6>
//                                     <p className="text-muted small mb-0">
//                                         Manage purchase order details and attachments
//                                     </p>
//                                 </div>
//                                 <div className="d-flex gap-2">
//                                     <Button
//                                         variant="outline-primary"
//                                         size="sm"
//                                         onClick={() => {
//                                             // Add functionality to edit PO details
//                                             console.log("Edit PO clicked");
//                                         }}
//                                         className="d-flex align-items-center"
//                                     >
//                                         <i className="mdi mdi-pencil-outline me-2"></i>
//                                         Edit PO
//                                     </Button>
//                                     <Button
//                                         variant="primary"
//                                         size="sm"
//                                         onClick={() => {
//                                             // Add functionality to upload new PO
//                                             console.log("Upload PO clicked");
//                                         }}
//                                         className="d-flex align-items-center"
//                                     >
//                                         <i className="mdi mdi-upload-outline me-2"></i>
//                                         Upload PO
//                                     </Button>
//                                 </div>
//                             </div>
//                         </Card.Body>
//                     </Card>
//                 </div> */}
//                                 </div>
//                             ) : (
//                                 <div className="text-center py-5">
//                                     <div className="spinner-border text-primary" role="status">
//                                         <span className="visually-hidden">Loading...</span>
//                                     </div>
//                                     <p className="mt-3 text-muted">Loading PO details...</p>
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     {/* Timeline Tab */}
//                     {activeTab === "timeline" && dealDetails && (
//                         <div className="tab-pane active">
//                             {timelineUpdates.length > 0 ? (
//                                 <div className="timeline-vertical">
//                                     {/* Existing timeline code remains the same */}
//                                     {/* ... */}
//                                 </div>
//                             ) : (
//                                 <div className="text-center py-5">
//                                     <div className="bg-light rounded p-5">
//                                         <FaRegClock className="text-muted mb-3" size={32} />
//                                         <h6 className="text-muted">No Timeline Activity</h6>
//                                         <p className="text-muted small mb-0">
//                                             There's no activity recorded in the timeline yet.
//                                         </p>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             </Offcanvas.Body>

//             {/* Deal Modal */}
//             {showModal && (
//                 <DealModal
//                     showModal={showModal}
//                     handleClose={() => setShowModal(false)}
//                     dealData={selectedDeal}
//                     editDeal={editDeal}
//                     fetchOrganisation={fetchOrganisation}
//                     fetchContacts={fetchContacts}
//                     contacts={contacts}
//                     organisations={organisations}
//                     dealId={dealId || id}
//                 />
//             )}

//             {/* Quotation Preview Modal */}
//             {showQuotationPreviewModal && selectedQuotationForPreview && (
//                 <QuotationPreviewModal
//                     showModal={showQuotationPreviewModal}
//                     handleClose={() => {
//                         setShowQuotationPreviewModal(false);
//                         setSelectedQuotationForPreview(null);
//                     }}
//                     onEdit={() => {
//                         // Handle edit if needed
//                     }}
//                     onDownload={() => handleDownloadPDF(
//                         selectedQuotationForPreview.id,
//                         selectedQuotationForPreview.ref_no
//                     )}
//                     clientName={selectedQuotationForPreview.project?.client?.name || "Client Name"}
//                     projectName={selectedQuotationForPreview.project?.name || "Project Name"}
//                     clientCurrency={selectedQuotationForPreview.project?.client?.currency || "AED"}
//                     brands={[]} // Pass appropriate brands data
//                     categories={{ allSubcategories: [], allCategoriesList: [] }} // Pass appropriate categories
//                     selectedProducts={selectedQuotationForPreview?.product_item_details || []}
//                     customIntegrationDescription={selectedQuotationForPreview.custom_integration_description || ""}
//                     customIntegrationTotal={selectedQuotationForPreview.custom_integration_total || 0}
//                     formData={selectedQuotationForPreview}
//                     editableDeploymentDescriptions={{}}
//                 />
//             )}
//         </Offcanvas>
//     );
// };

// export default DealDetails;



import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Container, Card, Tabs, Tab, Button, Offcanvas, Badge, Table, Dropdown } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";
import {
    FaRegClock,
    FaUserEdit,
    FaFileInvoice,
    FaTag,
    FaAddressCard,
    FaBuilding,
    FaUser,
    FaStickyNote,
    FaArrowRight,
    FaFileAlt,
    FaReceipt,
    FaShieldAlt
} from "react-icons/fa";
import moment from "moment";
import DealView from './DealView';
import SelectedContact from '../../contact/SelectedContact';
import withPermission from '../../../utils/withPermission';
import ActivityList from '../lead/activity/ActivityList';
import DealModal from './DealModal';
import DealPermissions from './DealPermissions';
import QuotationPreviewModal from '../../quotation/QuotationPreviewModal';
import { useAuth } from '../../../context/AuthContext';
import QuotationForm from '../../quotation/QuotationForm';
import { BsPlus, BsPencil, BsTrash, BsSearch, BsThreeDotsVertical } from "react-icons/bs";
import OrganisationDetails from "../organisation/OrganisationDetails";



const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);

const DealDetails = ({ show, onHide, dealId }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "activityList";
    const [dealDetails, setDealDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('activityList');
    const { roles, dataScopes } = useAuth();
    const isAllowedToReassign = roles?.some(role => role.toLowerCase() === 'superadmin') ||
        dataScopes?.some(scope => scope === 'all' || scope === 'team');
    const [activities, setActivities] = useState([]);
    const [quotations, setQuotations] = useState([]);
    const [poDetails, setPODetails] = useState(null);
    const [showQuotationPreviewModal, setShowQuotationPreviewModal] = useState(false);
    const [selectedQuotationForPreview, setSelectedQuotationForPreview] = useState(null);
    const [showQuotationModal, setShowQuotationModal] = useState(false);
    const [selectedQuotationId, setSelectedQuotationId] = useState(null);
    const [selectedQuotationData, setSelectedQuotationData] = useState(null);
    const [isOrder, setIsOrder] = useState(false);
    const [products, setProducts] = useState([]);
    const [productsFetched, setProductsFetched] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedDeal, setSelectedDeal] = useState(null);
    const [timelineUpdates, setTimelineUpdates] = useState([]);
    const [Deals, setDeal] = useState(null);
    const [contacts, setContacts] = useState([]);
    const [organisations, setOrganisation] = useState([]);
    const [reopenOffcanvas, setReopenOffcanvas] = useState(false);

    const didFetchRef = useRef(false);
    const [localShow, setLocalShow] = useState(show);
    const [isMinimizing, setIsMinimizing] = useState(false);

    const [showOrganisationDetails, setShowOrganisationDetails] = useState(false);
    const [selectedOrganisationIdForDetails, setSelectedOrganisationIdForDetails] = useState(null);

    const handleShowOrganisationDetails = (organisationId) => {
        setSelectedOrganisationIdForDetails(organisationId);
        setShowOrganisationDetails(true);
    };

    const handleCloseOrganisationDetails = () => {
        setShowOrganisationDetails(false);
        setSelectedOrganisationIdForDetails(null);
    };

    // Sync with parent show prop
    useEffect(() => {
        if (!isMinimizing) {
            setLocalShow(show);
        }
    }, [show, isMinimizing]);

    // Fetch quotations using the deal's quotation_id
    const fetchQuotations = async () => {
        try {
            if (!dealDetails?.quotation_id) {
                setQuotations([]);
                return;
            }

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Fetch the main quotation
            const mainQuotationResponse = await axios.get(`${backendUrl}/api/quotations/${dealDetails.quotation_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const mainQuotation = mainQuotationResponse.data.quotation;

            // If we need to fetch related quotations (versions), we can do it here
            const quotationsList = mainQuotationResponse.data.versions || [mainQuotationResponse.data.quotation];

            const formattedQuotations = quotationsList.map((quotation, index) => {
                const version = quotation.version || (index + 1);
                return {
                    ...quotation,
                    version: version,
                    displayRef: quotation.ref_no
                };
            });
            setQuotations(formattedQuotations);
        } catch (error) {
            console.error("Error fetching quotations:", error);
            setQuotations([]);
        }
    };

    // Group quotations by original and create versions
    const groupQuotationsByVersion = (quotationsList) => {
        const grouped = {};

        quotationsList.forEach(quotation => {
            const originalId = quotation.original_quotation_id || quotation.id;

            if (!grouped[originalId]) {
                grouped[originalId] = [];
            }

            // Add version number
            const version = grouped[originalId].length + 1;
            grouped[originalId].push({
                ...quotation,
                version: version,
                displayRef: version === 1 ? quotation.ref_no : `${quotation.ref_no}-${version}`
            });
        });

        // Flatten the grouped object into an array
        return Object.values(grouped).flat();
    };

    // Fetch PO details from deal data
    const fetchPODetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = dealId || id;
            const response = await axios.get(`${backendUrl}/api/deals/${currentId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const dealData = response.data.data;
            setPODetails({
                po_attachment: dealData.po_attachment,
                po_value: dealData.po_value,
                issue_date: dealData.issue_date,
                po_number: dealData.po_number
            });
        } catch (error) {
            console.error("Error fetching PO details:", error);
        }
    };

    const fetchTimelineUpdates = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = {};
            params.deal_id = dealId || id;

            if (!params.deal_id) {
                console.warn("Missing Deal_id, skipping API call.");
                return;
            }

            const response = await axios.get(`${backendUrl}/api/history/all`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
                params,
            });

            setTimelineUpdates(response.data.data);
        } catch (error) {
            console.error("Error fetching timeline updates:", error);
        }
    };

    const fetchDealDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = dealId || id;
            const response = await axios.get(`${backendUrl}/api/deals/${currentId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            const dealData = response.data.data;
            setDealDetails(dealData);

            // If deal has quotation_id, fetch quotations
            if (dealData.quotation_id) {
                await fetchQuotationsForDeal(dealData.quotation_id);
            } else {
                setQuotations([]);
            }

        } catch (error) {
            console.error('Error fetching Deal details:', error);
        }
    };

    // Enhanced function to fetch quotations using the deal's quotation_id
    const fetchQuotationsForDeal = async (quotationId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Fetch the main quotation
            const mainQuotationResponse = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const mainQuotation = mainQuotationResponse.data.quotation;

            // If you have a way to fetch quotation versions/history, add it here
            const quotationsList = mainQuotationResponse.data.versions || [mainQuotationResponse.data.quotation];

            const formattedQuotations = quotationsList.map((quotation, index) => {
                const version = quotation.version || (index + 1);
                return {
                    ...quotation,
                    version: version,
                    displayRef: quotation.ref_no
                };
            });
            setQuotations(formattedQuotations);
        } catch (error) {
            console.error("Error fetching quotations:", error);
            setQuotations([]);
        }
    };

    // Fetch activities
    const fetchActivities = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/activities`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    deal_id: dealId || id,
                },
                skipLoader: true,
            });

            setActivities(response.data.data || []);
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    };

    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const filteredContacts = response.data.Data.filter(
                contact => contact.type !== "instance" && contact.type !== "tenant"
            );

            setContacts(filteredContacts);
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setOrganisation(response.data?.data|| response.data?.data?.data || []);
        } catch (error) {
            console.error(`Error fetching organisations:`, error);
        }
    };

    const editDeal = async (contactId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/deals/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            if (response.data.success || response.status === 200) {
                await fetchDealDetails();
                await fetchTimelineUpdates();
                await fetchActivities();
            }

            setShowModal(false);
            if (reopenOffcanvas) {
                setReopenOffcanvas(false);
                setTimeout(() => {
                    onHide(false);
                }, 100);
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error(`Error updating Deal:`, error);
            }
        }
    };

    // Handle quotation edit
    const handleEditQuotation = async (quotationId) => {
        try {
            setSelectedQuotationId(quotationId);

            // Fetch the quotation data for editing
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setSelectedQuotationData(response.data.quotation);
            setIsMinimizing(true);
            setShowQuotationModal(true);
            // setLocalShow(false);
            setShowQuotationPreviewModal(false); // Close preview when opening edit

        } catch (error) {
            console.error("Error fetching quotation data:", error);
        }
    };

    // Handle edit from preview modal
    const handleEditFromPreview = () => {
        if (selectedQuotationForPreview) {
            setShowQuotationPreviewModal(false);
            handleEditQuotation(selectedQuotationForPreview.id);
        }
    };

    // Edit quotation function
    const editQuotation = async (quotationId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/quotations/${quotationId}?_method=PUT`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const updatedQuotation = response.data.quotation;

            if (updatedQuotation) {
                // Refresh quotations list
                if (dealDetails?.quotation_id) {
                    await fetchQuotationsForDeal(dealDetails.quotation_id);
                }

                setShowQuotationModal(false);
                setSelectedQuotationId(null);
                setSelectedQuotationData(null);

                // Show the updated quotation in preview
                setSelectedQuotationForPreview(updatedQuotation);
                setIsMinimizing(true);
                setShowQuotationPreviewModal(true);
                // setLocalShow(false);
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error('Error updating quotation:', error);
            }
        }
    };

    // Add quotation function
    const addQuotation = async (newQuotation) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/quotations`, newQuotation, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const createdQuotation = response.data.quotation;

            if (createdQuotation) {
                // Update deal with quotation_id
                await axios.put(`${backendUrl}/api/deals/${dealId || id}`, {
                    quotation_id: createdQuotation.id
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                // Refresh deal details and quotations
                await fetchDealDetails();

                setShowQuotationModal(false);
                setSelectedQuotationForPreview(createdQuotation);
                setShowQuotationPreviewModal(true);
                // setLocalShow(false);
            }
        } catch (error) {
            console.error("Error adding quotation:", error);
        }
    };

    useEffect(() => {
        if (localShow && (dealId || id)) {
            setDealDetails(null);
            fetchDealDetails();
            fetchActivities();
        }
    }, [localShow, dealId]);

    useEffect(() => {
        if (localShow && activeTab === 'timeline') {
            fetchTimelineUpdates();
        } else if (localShow && activeTab === 'poDetails') {
            fetchPODetails();
        }
        // quotations are now fetched automatically when dealDetails are loaded
    }, [localShow, activeTab]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleOffcanvasClose = () => {
        if (isMinimizing) return;
        setDealDetails(null);
        setActiveTab('activityList');
        didFetchRef.current = false;
        onHide();
    };

    // Handle quotation view
    const handleViewQuotation = async (quotationId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            let quotationToShow = response.data.quotation;
            if (response.data.versions && response.data.versions.length > 0) {
                quotationToShow = response.data.versions.reduce((latest, current) => {
                    return (current.version > latest.version) ? current : latest;
                }, response.data.versions[0]);
            }

            setSelectedQuotationForPreview(quotationToShow);
            setIsMinimizing(true);
            setShowQuotationPreviewModal(true);
            // setLocalShow(false);
        } catch (error) {
            console.error("Error fetching quotation for preview:", error);
        }
    };

    // Handle download PDF
    const handleDownloadPDF = async (quotationId, refNo) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}/download`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Quotation_${refNo}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading PDF:', error);
        }
    };

    // Handle create new quotation
    const handleCreateQuotation = () => {
        setSelectedQuotationId(null);
        setSelectedQuotationData(null);
        setIsMinimizing(true);
        setShowQuotationModal(true);
        // setLocalShow(false);
    };

    // Check if deal has quotation
    const hasQuotation = dealDetails?.quotation_id;

    const getIcon = (action) => {
        switch (action) {
            case "Opportunity Created":
                return <div className="timeline-icon-circle bg-success"><FaRegClock className="text-white" size={12} /></div>;
            case "Opportunity Updated":
                return <div className="timeline-icon-circle bg-primary"><FaUserEdit className="text-white" size={12} /></div>;
            case "Contact Added":
                return <div className="timeline-icon-circle bg-info"><FaAddressCard className="text-white" size={12} /></div>;
            case "status":
                return <div className="timeline-icon-circle bg-warning"><FaTag className="text-white" size={12} /></div>;
            default:
                return <div className="timeline-icon-circle bg-secondary"><FaRegClock className="text-white" size={12} /></div>;
        }
    };

    const groupByDate = (updates) => {
        return updates.reduce((grouped, update) => {
            const date = moment(update.created_at || new Date()).format("MMM DD, YYYY");
            if (!grouped[date]) {
                grouped[date] = [];
            }
            grouped[date].push(update);
            return grouped;
        }, {});
    };

    const groupedUpdates = groupByDate(timelineUpdates);

    // Enhanced Attachment Preview Component for PO
    // const AttachmentPreview = ({ attachmentUrl, showOriginalName = false }) => {
    //     if (!attachmentUrl) return null;

    //     const url = `${process.env.REACT_APP_BACKEND_URL}/storage/${attachmentUrl}`;
    //     const fileName = attachmentUrl.split('/').pop();
    //     const fileType = fileName.split('.').pop().toLowerCase();

    //     const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(fileType);
    //     const isPDF = fileType === 'pdf';
    //     const isDocument = ['doc', 'docx', 'txt'].includes(fileType);
    //     const isSpreadsheet = ['xls', 'xlsx', 'csv'].includes(fileType);

    //     const getFileIcon = () => {
    //         if (isPDF) return 'mdi-file-pdf-box text-danger';
    //         if (isImage) return 'mdi-file-image text-success';
    //         if (isDocument) return 'mdi-file-document text-primary';
    //         if (isSpreadsheet) return 'mdi-file-excel text-success';
    //         return 'mdi-file-document-outline text-secondary';
    //     };

    //     return (
    //         <div className="border rounded bg-white p-3">
    //             <div className="d-flex align-items-center justify-content-between mb-3">
    //                 <div className="d-flex align-items-center">
    //                     <i className={`mdi ${getFileIcon()} display-6 me-3`}></i>
    //                     <div>
    //                         <h6 className="mb-1 text-dark">{showOriginalName ? fileName : 'PO Attachment'}</h6>
    //                         <small className="text-muted">
    //                             {fileType.toUpperCase()} • {moment().format('MMM DD, YYYY')}
    //                         </small>
    //                     </div>
    //                 </div>
    //                 <Badge bg={isPDF ? "danger" : isImage ? "success" : "primary"}>
    //                     {fileType.toUpperCase()}
    //                 </Badge>
    //             </div>

    //             <div className="border rounded" style={{ maxHeight: '400px', overflow: 'auto' }}>
    //                 {isImage ? (
    //                     <img
    //                         src={url}
    //                         alt="PO Attachment"
    //                         className="img-fluid w-100"
    //                         style={{ maxHeight: '350px', objectFit: 'contain' }}
    //                     />
    //                 ) : isPDF ? (
    //                     <iframe
    //                         src={`${url}#toolbar=0&navpanes=0&view=FitH`}
    //                         title="PO Attachment"
    //                         width="100%"
    //                         height="350px"
    //                         frameBorder="0"
    //                         className="border-0"
    //                     />
    //                 ) : (
    //                     <div className="text-center py-5">
    //                         <i className={`mdi ${getFileIcon()} display-1 text-muted mb-3`}></i>
    //                         <p className="text-muted mb-2">Preview not available</p>
    //                         <small className="text-muted">
    //                             Download the file to view {isDocument ? 'document' : isSpreadsheet ? 'spreadsheet' : 'content'}
    //                         </small>
    //                     </div>
    //                 )}
    //             </div>
    //         </div>
    //     );
    // };

    const AttachmentPreview = ({ attachmentUrl, showOriginalName = false }) => {
        if (!attachmentUrl) return null;

        const url = `${process.env.REACT_APP_BACKEND_URL}/storage/${attachmentUrl}`;
        const fileName = attachmentUrl.split('/').pop();
        const fileType = fileName.split('.').pop().toLowerCase();

        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(fileType);
        const isPDF = fileType === 'pdf';
        const isDocument = ['doc', 'docx', 'txt'].includes(fileType);
        const isSpreadsheet = ['xls', 'xlsx', 'csv'].includes(fileType);

        const getFileIcon = () => {
            if (isPDF) return 'mdi-file-pdf-box text-danger';
            if (isImage) return 'mdi-file-image text-success';
            if (isDocument) return 'mdi-file-document text-primary';
            if (isSpreadsheet) return 'mdi-file-excel text-success';
            return 'mdi-file-document-outline text-secondary';
        };

        return (
            <div className="border rounded bg-white p-3">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                        <i className={`mdi ${getFileIcon()} display-6 me-3`}></i>
                        <div>
                            <h6 className="mb-1 text-dark">{showOriginalName ? fileName : 'PO Attachment'}</h6>
                            <small className="text-muted">
                                {fileType.toUpperCase()} • {moment().format('MMM DD, YYYY')}
                            </small>
                        </div>
                    </div>
                    <Badge bg={isPDF ? "danger" : isImage ? "success" : "primary"}>
                        {fileType.toUpperCase()}
                    </Badge>
                </div>

                {/* Fixed container - no scrollbars, fixed size */}
                <div className="border rounded bg-light d-flex justify-content-center align-items-center p-2"
                    style={{
                        width: '100%',
                        height: '600px',
                        overflow: 'hidden'
                    }}>
                    {isImage ? (
                        <img
                            src={url}
                            alt="PO Attachment"
                            style={{
                                maxHeight: '100%',
                                maxWidth: '100%',
                                objectFit: 'contain'
                            }}
                        />
                    ) : isPDF ? (
                        <iframe
                            src={`${url}#toolbar=0&navpanes=0&view=FitH`}
                            title="PO Attachment"
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            style={{
                                border: 'none',
                                overflow: 'hidden'
                            }}
                        />
                    ) : (
                        <div className="text-center py-5">
                            <i className={`mdi ${getFileIcon()} display-1 text-muted mb-3`}></i>
                            <p className="text-muted mb-2">Preview not available</p>
                            <small className="text-muted">
                                Download the file to view {isDocument ? 'document' : isSpreadsheet ? 'spreadsheet' : 'content'}
                            </small>
                        </div>
                    )}
                </div>
            </div>
        );
    };
    return (
        <>
            <Offcanvas
                show={localShow}
                onHide={handleOffcanvasClose}
                placement="end"
                style={{
                    width: '1050px',
                    ...(isMinimizing ? { visibility: 'hidden', opacity: 0, pointerEvents: 'none' } : {})
                }}
                backdropClassName={isMinimizing ? 'd-none' : ''}
                className={`lead-offcanvas ${isMinimizing ? 'minimized' : ''}`}
                enforceFocus={false}
                autoFocus={false}
                restoreFocus={false}
                unmountOnExit={false}
            >

                {/* Offcanvas Header */}
                <Offcanvas.Header className="border-bottom bg-white py-3">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle p-2 me-3">
                                <FaUser className="text-white" size={18} />
                            </div>
                            <div>
                                <h5 className="mb-0 fw-bold text-dark">{dealDetails?.name}</h5>
                            </div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => {
                                    setSelectedDeal(dealDetails);
                                    setIsMinimizing(true);
                                    setShowModal(true);
                                    // setLocalShow(false);
                                }}
                            >
                                <BiPencil className="me-1" />
                                Edit Deal
                            </Button>
                            <Button
                                variant="light"
                                size="sm"
                                onClick={handleOffcanvasClose}
                                className="border-0"
                            >
                                <BsX size={20} />
                            </Button>
                        </div>
                    </div>
                </Offcanvas.Header>

                {/* Offcanvas Body */}
                <Offcanvas.Body className="p-0">
                    {/* Deal Summary Card */}
                    <div className="p-4 border-bottom bg-light">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                        <FaBuilding className="text-primary" size={16} />
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Organisation</label>
                                        <h6 
                                            className="mb-0 fw-semibold text-dark" 
                                            onClick={() => dealDetails?.organisation?.id && handleShowOrganisationDetails(dealDetails.organisation.id)}
                                            style={{ cursor: 'pointer', color: '#2F7EF7' }}
                                        >
                                            {dealDetails?.organisation?.name || 'Not assigned'}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                        <FaTag className="text-primary" size={16} />
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Lead Source</label>
                                        <h6 className="mb-0 fw-semibold text-dark text-capitalize">
                                            {dealDetails?.lead_source ? dealDetails.lead_source.replace('_', ' ') : 'Not specified'}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-start">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
                                        <FaStickyNote className="text-primary" size={16} />
                                    </div>
                                    <div className="flex-grow-1">
                                        <label className="text-muted small mb-1 d-block">Customer Type</label>
                                        <div>
                                            <h6 className="mb-0 fw-semibold text-dark text-capitalize">
                                                {dealDetails?.customer_type ? dealDetails.customer_type.replace('_', ' ') : 'Not specified'}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {dealDetails?.lead_source === 'partner' && (
                                <div className="col-md-6">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                            <i className="mdi mdi-swap-horizontal text-primary" style={{ fontSize: '16px' }}></i>
                                        </div>
                                        <div>
                                            <label className="text-muted small mb-1 d-block">Partner Name</label>
                                            <h6 className="mb-0 fw-semibold text-dark text-capitalize">
                                                {dealDetails?.partner_organisation?.name || dealDetails?.partner_name || dealDetails?.partner?.name || 'Not specified'}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {dealDetails?.lead_source === 'partner' && dealDetails?.partner_organisation && (
                                <div className="col-md-6">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                            <i className="mdi mdi-handshake text-primary" style={{ fontSize: '16px' }}></i>
                                        </div>
                                        <div>
                                            <label className="text-muted small mb-1 d-block">Partner</label>
                                            <h6 className="mb-0 fw-semibold text-dark">
                                                {dealDetails?.partner_organisation?.name || dealDetails?.partner_name || dealDetails?.partner?.name || 'Not specified'}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                        <FaRegClock className="text-primary" size={16} />
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Created Date</label>
                                        <h6 className="mb-0 fw-semibold text-dark">
                                            {dealDetails?.created_date ? moment(dealDetails.created_date).format('DD-MM-YYYY') : dealDetails?.created_at ? moment(dealDetails.created_at).format('DD-MM-YYYY') : '-'}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Navigation Tabs */}
                    <div className="border-bottom bg-white">
                        <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                            <WithActivityPermission>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'activityList' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('activityList')}
                                        role="tab"
                                    >
                                        <FaRegClock className="me-2" size={14} />
                                        Activities

                                    </button>
                                </li>
                            </WithActivityPermission>
                            <WithContactPermission>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('contactList')}
                                        role="tab"
                                    >
                                        <FaUser className="me-2" size={14} />
                                        Contacts
                                    </button>
                                </li>
                            </WithContactPermission>

                            {/* Quotations Tab */}
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'quotations' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('quotations')}
                                    role="tab"
                                >
                                    <FaFileAlt className="me-2" size={14} />
                                    Quotations

                                </button>
                            </li>

                            {/* PO Details Tab */}
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'poDetails' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('poDetails')}
                                    role="tab"
                                >
                                    <FaReceipt className="me-2" size={14} />
                                    PO Details
                                </button>
                            </li>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'dealDetails' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('dealDetails')}
                                    role="tab"
                                >
                                    <FaBuilding className="me-2" size={14} />
                                    Details
                                </button>
                            </li>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`}
                                    onClick={() => {
                                        handleTabClick('timeline');
                                        fetchTimelineUpdates();
                                    }}
                                    role="tab"
                                >
                                    <FaRegClock className="me-2" size={14} />
                                    Timeline

                                </button>
                            </li>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'permissions' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('permissions')}
                                    role="tab"
                                >
                                    <FaShieldAlt className="me-2" size={14} />
                                    Assign
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>

                        {/* Contact List Tab */}
                        {activeTab === "contactList" && dealDetails && (
                            <div className="tab-pane active">
                                <SelectedContact
                                    dealId={dealDetails?.id}
                                    entityType="deal"
                                    fetchDealData={fetchDealDetails}
                                    dealData={dealDetails}
                                    setDealDetails={setDealDetails}
                                    onCloseOffcanvas={() => {
                                        setIsMinimizing(true);
                                        // setLocalShow(false);
                                    }}
                                    onReopenOffcanvas={() => {
                                        setIsMinimizing(false);
                                        // setLocalShow(true);
                                    }}
                                />
                            </div>
                        )}

                        {/* Activity List Tab */}
                        {activeTab === "activityList" && dealDetails && (
                            <div className="tab-pane active">
                                <ActivityList
                                    dealId={dealDetails?.id}
                                    type='deal'
                                    fetchDealData={fetchDealDetails}
                                    leadData={dealDetails}
                                    setDealDetails={setDealDetails}
                                    onModalShow={() => {
                                        setIsMinimizing(true);
                                        // setLocalShow(false);
                                    }}
                                    onModalClose={() => {
                                        setIsMinimizing(false);
                                        // setLocalShow(true);
                                    }}
                                />
                            </div>
                        )}

                        {/* Deal Details Tab */}
                        {activeTab === "dealDetails" && (
                            <div className="tab-pane active">
                                {dealDetails ? (
                                    <DealView
                                        data={dealDetails}
                                        dealId={dealId || id}
                                        setDealDetails={setDealDetails}
                                    />
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2 text-muted">Loading Deal details...</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Quotations Tab */}
                        {activeTab === "quotations" && (
                            <div className="tab-pane active">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Quotations</h5>
                                    <div className="d-flex align-items-center gap-2">

                                        {/* <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={handleCreateQuotation}
                                        className="d-flex align-items-center"
                                    >
                                        <i className="mdi mdi-plus me-1"></i>
                                        Create Quotation
                                    </Button> */}
                                    </div>
                                </div>

                                {hasQuotation ? (
                                    quotations.length > 0 ? (
                                        <div className="contacts-table-modern">
                                            <div className="table-responsive">
                                                <table className="table table-modern">
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Ref No</th>
                                                            <th>Amount</th>

                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {quotations.map((quotation) => (
                                                            <tr key={quotation.id}>
                                                                <td>
                                                                    {quotation.created_at 
                                                                        ? moment(quotation.created_at).format('MMM DD, YYYY') 
                                                                        : quotation.date 
                                                                            ? moment(quotation.date).format('MMM DD, YYYY') 
                                                                            : '--'
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <button className='dropdown-item'
                                                                        onClick={() => handleViewQuotation(quotation.id)}
                                                                    >

                                                                        <strong>{quotation.displayRef}</strong>
                                                                    </button>
                                                                </td>

                                                                <td>
                                                                    {Number(quotation.amount || 0).toLocaleString('en-US', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </td>



                                                                <td className="text-center">
                                                                    <Dropdown drop='up'>
                                                                        <Dropdown.Toggle
                                                                            variant="outline-light"
                                                                            size="sm"
                                                                            className="border-0 shadow-none"
                                                                            id={`dropdown-${quotation.id}`}
                                                                        >
                                                                            <BsThreeDotsVertical className="text-muted" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className="font-size-14">
                                                                            <Dropdown.Item
                                                                                onClick={() => handleViewQuotation(quotation.id)}
                                                                                className="d-flex align-items-center gap-2"
                                                                            >

                                                                                View
                                                                            </Dropdown.Item>


                                                                            <Dropdown.Item
                                                                                onClick={() => handleEditQuotation(quotation.id)}
                                                                                className="d-flex align-items-center gap-2"
                                                                            >

                                                                                Edit
                                                                            </Dropdown.Item>


                                                                            <Dropdown.Item
                                                                                onClick={() => handleDownloadPDF(quotation.id, quotation.displayRef)}
                                                                                className="d-flex align-items-center gap-2 text-danger"
                                                                            >

                                                                                Download
                                                                            </Dropdown.Item>


                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-2 text-muted">Loading quotations...</p>
                                        </div>
                                    )
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="bg-light rounded p-5">
                                            <FaFileAlt className="text-muted mb-3" size={32} />
                                            <h6 className="text-muted">No Quotations Found</h6>
                                            <p className="text-muted small mb-3">
                                                No quotations have been created for this deal yet.
                                            </p>
                                            <Button
                                                variant="primary"
                                                onClick={handleCreateQuotation}
                                            >
                                                Create First Quotation
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* PO Details Tab */}
                        {activeTab === "poDetails" && (
                            <div className="tab-pane active">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0 text-dark">Purchase Order Details</h5>
                                    <Badge bg={poDetails?.po_attachment ? "success" : "secondary"} className="fs-6">
                                        {poDetails?.po_attachment ? "PO Attached" : "No PO"}
                                    </Badge>
                                </div>

                                {poDetails ? (
                                    <div className="row">
                                        {/* PO Attachment Card */}
                                        <div className="col-12">
                                            <Card className="border-0 shadow-sm">
                                                <Card.Header className="bg-white border-bottom py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                    <h6 className="mb-0 text-dark">
                                                        <i className="mdi mdi-paperclip me-2 text-primary"></i>
                                                        PO Attachment
                                                    </h6>
                                                    <div className="d-flex flex-wrap gap-4 align-items-center bg-light rounded px-3 py-2 border">
                                                        <div className="d-flex align-items-center">
                                                            <span className="text-muted small me-2">PO No:</span>
                                                            <span className="fw-semibold text-dark">{poDetails?.po_number || 'N/A'}</span>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <span className="text-muted small me-2">Date:</span>
                                                            <span className="fw-semibold text-dark">
                                                                {poDetails?.issue_date ? moment(poDetails.issue_date).format('MMM DD, YYYY') : 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <span className="text-muted small me-2">Value:</span>
                                                            <span className="fw-bold text-success">
                                                                {poDetails?.po_value ? Number(poDetails.po_value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body className="p-4">
                                                    {poDetails?.po_attachment ? (
                                                        <div className="">
                                                            <div style={{ width: '100%', height: '80vh' }}>
                                                                <AttachmentPreview
                                                                    attachmentUrl={poDetails.po_attachment}
                                                                    showOriginalName={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center py-5">
                                                            <div className="bg-light rounded p-5">
                                                                <i className="mdi mdi-file-remove-outline display-4 text-muted mb-3"></i>
                                                                <h6 className="text-muted">No PO Attachment</h6>
                                                                <p className="text-muted small mb-3">
                                                                    No purchase order attachment has been uploaded for this deal.
                                                                </p>
                                                                <Badge bg="secondary" className="fs-7">
                                                                    Awaiting Upload
                                                                </Badge>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        </div>

                                        {/* PO Attachment Card */}
                                        {/* <div className="col-12">
                                        <Card className="border-0 shadow-sm">
                                            <Card.Header className="bg-white border-bottom-0 py-3">
                                                <h6 className="mb-0 text-dark">
                                                    <i className="mdi mdi-paperclip me-2 text-primary"></i>
                                                    PO Attachment
                                                </h6>
                                            </Card.Header>
                                            <Card.Body className="p-4">
                                                {poDetails.po_attachment ? (
                                                    <div className="row align-items-center">
                                                        <div className="col-md-8">
                                                            <AttachmentPreview
                                                                attachmentUrl={poDetails.po_attachment}
                                                                showOriginalName={true}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="text-center py-5">
                                                        <div className="bg-light rounded p-5">
                                                            <i className="mdi mdi-file-remove-outline display-4 text-muted mb-3"></i>
                                                            <h6 className="text-muted">No PO Attachment</h6>
                                                            <p className="text-muted small mb-3">
                                                                No purchase order attachment has been uploaded for this deal.
                                                            </p>
                                                            <Badge bg="secondary" className="fs-7">
                                                                Awaiting Upload
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </div> */}
                                    </div>
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-3 text-muted">Loading PO details...</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Timeline Tab */}
                        {activeTab === "timeline" && dealDetails && (
                            <div className="tab-pane active">
                                {timelineUpdates.length > 0 ? (
                                    <div className="timeline-vertical">
                                        <div className="timeline">
                                            {timelineUpdates.length > 0 && Object.entries(groupByDate(timelineUpdates))
                                                .sort(([dateA], [dateB]) => new Date(dateB === "Invalid date" ? new Date() : dateB) - new Date(dateA === "Invalid date" ? new Date() : dateA))
                                                .map(([date, updates]) => (
                                                    <div key={date} className="timeline-date-group">
                                                        <div className="timeline-date-box font-size-13">{date}</div>
                                                        {updates
                                                            .sort((a, b) => new Date(b.created_at || new Date()) - new Date(a.created_at || new Date()))
                                                            .map((update, index) => {
                                                                let title = update.action;
                                                                if (title && title.includes('Deal')) {
                                                                    title = title.replace(/Deal/gi, 'Opportunity');
                                                                }
                                                                let details = null;

                                                                const formatFieldName = (field) => {
                                                                    return field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
                                                                };

                                                                if (update.history_type === "activity") {
                                                                    if (update.action && update.action.endsWith("added")) {
                                                                        title = update.data?.subject || "Activity";
                                                                    } else if (update.action && update.action.endsWith("updated")) {
                                                                        title = `${update.data?.subject || 'Activity'} updated`;
                                                                        if (update.data?.changes) {
                                                                            details = Object.entries(update.data.changes)
                                                                                .filter(([key]) => !["created_at", "updated_at", "deal", "client_id", "project_id", "quotation_id"].includes(key))
                                                                                .map(([key, change]) => (
                                                                                    <div key={key}>
                                                                                        <strong>{formatFieldName(key)}</strong> changed from <strong>{typeof change.old === 'object' && change.old !== null ? (change.old.name || change.old.id || '[Object]') : String(change.old || '-')}</strong> to <strong>{typeof change.new === 'object' && change.new !== null ? (change.new.name || change.new.id || '[Object]') : String(change.new || '-')}</strong>
                                                                                    </div>
                                                                                ));
                                                                        }
                                                                    }
                                                                } else if (update.history_type === "deal") {
                                                                    if (update.action === "Deal Reassigned" || update.action === "Opportunity Reassigned") {
                                                                        title = `Opportunity Reassigned`;
                                                                        details = (
                                                                            <div>
                                                                                From <strong>{update.data?.from || 'N/A'}</strong> to <strong>{update.data?.to || 'N/A'}</strong>
                                                                            </div>
                                                                        );
                                                                    } else if (update.data?.old?.stage !== undefined && update.data?.new?.stage !== undefined && update.data.old.stage !== update.data.new.stage) {
                                                                        title = `Stage changed from ${update.data.old.stage} to ${update.data.new.stage}`;
                                                                        details = `Probability changed from ${update.data.old.probability || 0}% to ${update.data.new.probability || 0}%`;
                                                                    } else if (update.data?.old && update.data?.new) {
                                                                        details = Object.entries(update.data.new)
                                                                            .filter(([key]) => !["updated_at", "created_at", "client_id", "project_id", "quotation_id"].includes(key))
                                                                            .map(([key, value]) => (
                                                                                <div key={key}>
                                                                                    <strong>{formatFieldName(key)}</strong> changed from <strong>{typeof update.data.old[key] === 'object' && update.data.old[key] !== null ? (update.data.old[key].name || update.data.old[key].id || '[Object]') : String(update.data.old[key] || '-')}</strong> to <strong>{typeof value === 'object' && value !== null ? (value.name || value.id || '[Object]') : String(value || '-')}</strong>
                                                                                </div>
                                                                            ));
                                                                    }
                                                                }

                                                                return (
                                                                    <div key={index} className="timeline-item">
                                                                        <div className="timeline-time">
                                                                            {moment(update.created_at || new Date()).format("h:mm A")}
                                                                        </div>
                                                                        <div className="timeline-icon">{getIcon(update.action)}</div>
                                                                        <div className="timeline-line"></div>
                                                                        <div className="timeline-content">
                                                                            <p className="timeline-title fw-semibold mb-1">{title}</p>
                                                                            {details && <div className="timeline-details small text-muted">{details}</div>}
                                                                            <p className="timeline-byline mt-1">
                                                                                <small className="text-muted">by {update.created_by || 'System'} • {moment(update.created_at || new Date()).format("MMM DD, YYYY")}</small>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="bg-light rounded p-5">
                                            <FaRegClock className="text-muted mb-3" size={32} />
                                            <h6 className="text-muted">No Timeline Activity</h6>
                                            <p className="text-muted small mb-0">
                                                There's no activity recorded in the timeline yet.
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {activeTab === 'permissions' && (
                            <div className="tab-pane active">
                                <DealPermissions
                                    dealId={dealId || id}
                                    dealData={dealDetails}
                                    fetchDealDetails={fetchDealDetails}
                                />
                            </div>
                        )}
                    </div>
                </Offcanvas.Body>

            </Offcanvas>

            {/* Deal Modal */}
            {showModal && (
                <DealModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                        setIsMinimizing(false);
                        setLocalShow(true);
                    }}
                    dealData={selectedDeal}
                    editDeal={editDeal}
                    fetchOrganisation={fetchOrganisation}
                    fetchContacts={fetchContacts}
                    contacts={contacts}
                    organisations={organisations}
                    dealId={dealId || id}
                />
            )}

            {/* Quotation Form Modal */}
            {showQuotationModal && (
                <QuotationForm
                    showModal={showQuotationModal}
                    handleClose={() => {
                        setShowQuotationModal(false);
                        setSelectedQuotationId(null);
                        setSelectedQuotationData(null);
                        setIsMinimizing(false);
                        setLocalShow(true);
                    }}
                    quotationId={selectedQuotationId}
                    quotationData={selectedQuotationData}
                    projectId={dealDetails?.project_id}
                    defaultClientId={dealDetails?.client_id}
                    projectName={dealDetails?.name || "Project Name"}
                    clientName={dealDetails?.organisation?.name || "Client Name"}
                    clientCurrency={dealDetails?.organisation?.currency || "AED"}
                    isOrder={isOrder}
                    products={products}
                    addQuotation={addQuotation}
                    setProducts={setProducts}
                    dealData={dealDetails}
                    editQuotation={editQuotation}
                />
            )}

            {/* Quotation Preview Modal */}
            {showQuotationPreviewModal && selectedQuotationForPreview && (
                <QuotationPreviewModal
                    showModal={showQuotationPreviewModal}
                    handleClose={() => {
                        setShowQuotationPreviewModal(false);
                        setSelectedQuotationForPreview(null);
                        setIsMinimizing(false);
                        setLocalShow(true);
                    }}
                    onEdit={handleEditFromPreview}
                    onDownload={() => handleDownloadPDF(
                        selectedQuotationForPreview.id,
                        selectedQuotationForPreview.ref_no
                    )}
                    clientName={selectedQuotationForPreview.project?.client?.name || "Client Name"}
                    projectName={selectedQuotationForPreview.project?.name || "Project Name"}
                    clientCurrency={selectedQuotationForPreview.project?.client?.currency || "AED"}
                    brands={[]}
                    categories={{ allSubcategories: [], allCategoriesList: [] }}
                    selectedProducts={selectedQuotationForPreview?.product_item_details || []}
                    customIntegrationDescription={selectedQuotationForPreview.custom_integration_description || ""}
                    customIntegrationTotal={selectedQuotationForPreview.custom_integration_total || 0}
                    formData={selectedQuotationForPreview}
                    editableDeploymentDescriptions={{}}
                    isUploaded={selectedQuotationForPreview.is_uploaded === true || selectedQuotationForPreview.is_uploaded === 1 || selectedQuotationForPreview.is_uploaded === '1'}
                    uploadedFileUrl={selectedQuotationForPreview.quotation_file}
                />
            )}

            {showOrganisationDetails && (
                <OrganisationDetails
                    showOffcanvas={showOrganisationDetails}
                    handleClose={handleCloseOrganisationDetails}
                    organisationId={selectedOrganisationIdForDetails}
                    onOrganisationUpdate={fetchDealDetails}
                />
            )}
        </>
    );
};

export default DealDetails;
